import React, { useRef, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Collapse, Divider, FormControlLabel, IconButton, Link, ListItem, ListItemButton, Typography, useTheme, Grid, Paper, useMediaQuery, AccordionActions } from "@mui/material";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import QuestionnaireForm from '../../components/QuestionnaireForm';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import ListMapFunc from './listMapFunc';
import Header from '../../components/Header';
import WidgetWrapper from '../../components/WidgetWrapper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import csfTiers from './images/csfTiers.png';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend } from 'recharts';
import CSFResults from './CSFResults';



const CSFAssessment = () => {

  // const [questions, setQuestions] = useState();
  const axiosPrivate = useAxiosPrivate();
  const { assessmentID } = useParams();
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");    // From mern_app project
  const isNonMobile = useMediaQuery("(min-width:600px)");             // From mern_app project
  const theme = useTheme();

  const [questions2, setQuestions2] = useState();

  const [openInstructions, setOpenInstructions] = useState(true);

  const [allAssessmentData, setAllAssessmentData] = useState([]);

  const governScore = {};
  const identifyScore = {};
  const protectScore = {};
  const detectScore = {};
  const respondScore = {};
  const recoverScore ={};

  const questionListGVOC = [];
  const questionListGVRM = [];
  const questionListGVRR = [];
  const questionListGVPO = [];
  const questionListGVOV = [];
  const questionListGVSC = [];
  const questionListIDAM = [];
  const questionListIDRA = [];
  const questionListIDIM = [];
  const questionListPRAA = [];
  const questionListPRAT = [];
  const questionListPRDS = [];
  const questionListPRPS = [];
  const questionListPRIR = [];
  const questionListDECM = [];
  const questionListDEAE = [];
  const questionListRSMA = [];
  const questionListRSAN = [];
  const questionListRSCO = [];
  const questionListRSMI = [];
  const questionListRCRP = [];
  const questionListRCCO = [];

  const [questionsLIST, setQuestionsLIST] = useState([]);

  const [gvoc1, setGvoc1] = useState("");
  const [gvoc2, setGvoc2] = useState("");
  const [gvoc3, setGvoc3] = useState("");
  const [gvoc4, setGvoc4] = useState("");
  const [gvoc5, setGvoc5] = useState("");
  const [gvoc1Comments, setGvoc1Comments] = useState("");
  const [gvoc2Comments, setGvoc2Comments] = useState("");
  const [gvoc3Comments, setGvoc3Comments] = useState("");
  const [gvoc4Comments, setGvoc4Comments] = useState("");
  const [gvoc5Comments, setGvoc5Comments] = useState("");

  const [gvrm1, setGvrm1] = useState("");
  const [gvrm2, setGvrm2] = useState("");
  const [gvrm3, setGvrm3] = useState("");
  const [gvrm4, setGvrm4] = useState("");
  const [gvrm5, setGvrm5] = useState("");
  const [gvrm6, setGvrm6] = useState("");
  const [gvrm7, setGvrm7] = useState("");
  const [gvrm1Comments, setGvrm1Comments] = useState("");
  const [gvrm2Comments, setGvrm2Comments] = useState("");
  const [gvrm3Comments, setGvrm3Comments] = useState("");
  const [gvrm4Comments, setGvrm4Comments] = useState("");
  const [gvrm5Comments, setGvrm5Comments] = useState("");
  const [gvrm6Comments, setGvrm6Comments] = useState("");
  const [gvrm7Comments, setGvrm7Comments] = useState("");

  const [gvrr1, setGvrr1] = useState("");
  const [gvrr2, setGvrr2] = useState("");
  const [gvrr3, setGvrr3] = useState("");
  const [gvrr4, setGvrr4] = useState("");
  const [gvrr1Comments, setGvrr1Comments] = useState("");
  const [gvrr2Comments, setGvrr2Comments] = useState("");
  const [gvrr3Comments, setGvrr3Comments] = useState("");
  const [gvrr4Comments, setGvrr4Comments] = useState("");

  const [gvpo1, setGvpo1] = useState("");
  const [gvpo2, setGvpo2] = useState("");
  const [gvpo1Comments, setGvpo1Comments] = useState("");
  const [gvpo2Comments, setGvpo2Comments] = useState("");

  const [gvov1, setGvov1] = useState("");
  const [gvov2, setGvov2] = useState("");
  const [gvov3, setGvov3] = useState("");
  const [gvov1Comments, setGvov1Comments] = useState("");
  const [gvov2Comments, setGvov2Comments] = useState("");
  const [gvov3Comments, setGvov3Comments] = useState("");

  const [gvsc1, setGvsc1] = useState("");
  const [gvsc2, setGvsc2] = useState("");
  const [gvsc3, setGvsc3] = useState("");
  const [gvsc4, setGvsc4] = useState("");
  const [gvsc5, setGvsc5] = useState("");
  const [gvsc6, setGvsc6] = useState("");
  const [gvsc7, setGvsc7] = useState("");
  const [gvsc8, setGvsc8] = useState("");
  const [gvsc9, setGvsc9] = useState("");
  const [gvsc10, setGvsc10] = useState("");
  const [gvsc1Comments, setGvsc1Comments] = useState("");
  const [gvsc2Comments, setGvsc2Comments] = useState("");
  const [gvsc3Comments, setGvsc3Comments] = useState("");
  const [gvsc4Comments, setGvsc4Comments] = useState("");
  const [gvsc5Comments, setGvsc5Comments] = useState("");
  const [gvsc6Comments, setGvsc6Comments] = useState("");
  const [gvsc7Comments, setGvsc7Comments] = useState("");
  const [gvsc8Comments, setGvsc8Comments] = useState("");
  const [gvsc9Comments, setGvsc9Comments] = useState("");
  const [gvsc10Comments, setGvsc10Comments] = useState("");


// ****** ID AM
  const [idam1, setIdam1] = useState("");
  const [idam2, setIdam2] = useState("");
  const [idam3, setIdam3] = useState("");
  const [idam4, setIdam4] = useState("");
  const [idam5, setIdam5] = useState("");
  const [idam7, setIdam7] = useState("");
  const [idam8, setIdam8] = useState("");
  const [idam1Comments, setIdam1Comments] = useState("");
  const [idam2Comments, setIdam2Comments] = useState("");
  const [idam3Comments, setIdam3Comments] = useState("");
  const [idam4Comments, setIdam4Comments] = useState("");
  const [idam5Comments, setIdam5Comments] = useState("");
  const [idam7Comments, setIdam7Comments] = useState("");
  const [idam8Comments, setIdam8Comments] = useState("");


  // **** ID RA
  const [idra1, setIdra1] = useState("");
  const [idra2, setIdra2] = useState("");
  const [idra3, setIdra3] = useState("");
  const [idra4, setIdra4] = useState("");
  const [idra5, setIdra5] = useState("");
  const [idra6, setIdra6] = useState("");
  const [idra7, setIdra7] = useState("");
  const [idra8, setIdra8] = useState("");
  const [idra9, setIdra9] = useState("");
  const [idra10, setIdra10] = useState("");
  const [idra1Comments, setIdra1Comments] = useState("");
  const [idra2Comments, setIdra2Comments] = useState("");
  const [idra3Comments, setIdra3Comments] = useState("");
  const [idra4Comments, setIdra4Comments] = useState("");
  const [idra5Comments, setIdra5Comments] = useState("");
  const [idra6Comments, setIdra6Comments] = useState("");
  const [idra7Comments, setIdra7Comments] = useState("");
  const [idra8Comments, setIdra8Comments] = useState("");
  const [idra9Comments, setIdra9Comments] = useState("");
  const [idra10Comments, setIdra10Comments] = useState("");


  // **** ID IM
  const [idim1, setIdim1] = useState("");
  const [idim2, setIdim2] = useState("");
  const [idim3, setIdim3] = useState("");
  const [idim4, setIdim4] = useState("");
  const [idim1Comments, setIdim1Comments] = useState("");
  const [idim2Comments, setIdim2Comments] = useState("");
  const [idim3Comments, setIdim3Comments] = useState("");
  const [idim4Comments, setIdim4Comments] = useState("");

  // **** PR AA
  const [praa1, setPraa1] = useState("");
  const [praa2, setPraa2] = useState("");
  const [praa3, setPraa3] = useState("");
  const [praa4, setPraa4] = useState("");
  const [praa5, setPraa5] = useState("");
  const [praa6, setPraa6] = useState("");
  const [praa1Comments, setPraa1Comments] = useState("");
  const [praa2Comments, setPraa2Comments] = useState("");
  const [praa3Comments, setPraa3Comments] = useState("");
  const [praa4Comments, setPraa4Comments] = useState("");
  const [praa5Comments, setPraa5Comments] = useState("");
  const [praa6Comments, setPraa6Comments] = useState("");

  // **** PR AT
  const [prat1, setPrat1] = useState("");
  const [prat2, setPrat2] = useState("");
  const [prat1Comments, setPrat1Comments] = useState("");
  const [prat2Comments, setPrat2Comments] = useState("");

  // **** PR DS <---- ADD VARIABLES FOR DS, PS, IR,
  const [prds1, setPrds1] = useState("");
  const [prds2, setPrds2] = useState("");
  const [prds10, setPrds10] = useState("");
  const [prds11, setPrds11] = useState("");
  const [prds1Comments, setPrds1Comments] = useState("");
  const [prds2Comments, setPrds2Comments] = useState("");
  const [prds10Comments, setPrds10Comments] = useState("");
  const [prds11Comments, setPrds11Comments] = useState("");

  // ***** PR PS
  const [prps1, setPrps1] = useState("");
  const [prps2, setPrps2] = useState("");
  const [prps3, setPrps3] = useState("");
  const [prps4, setPrps4] = useState("");
  const [prps5, setPrps5] = useState("");
  const [prps6, setPrps6] = useState("");
  const [prps1Comments, setPrps1Comments] = useState("");
  const [prps2Comments, setPrps2Comments] = useState("");
  const [prps3Comments, setPrps3Comments] = useState("");
  const [prps4Comments, setPrps4Comments] = useState("");
  const [prps5Comments, setPrps5Comments] = useState("");
  const [prps6Comments, setPrps6Comments] = useState("");

  // **** PR IR
  const [prir1, setPrir1] = useState("");
  const [prir2, setPrir2] = useState("");
  const [prir3, setPrir3] = useState("");
  const [prir4, setPrir4] = useState("");
  const [prir1Comments, setPrir1Comments] = useState("");
  const [prir2Comments, setPrir2Comments] = useState("");
  const [prir3Comments, setPrir3Comments] = useState("");
  const [prir4Comments, setPrir4Comments] = useState("");

  // DE CM
  const [decm1, setDecm1] = useState("");
  const [decm2, setDecm2] = useState("");
  const [decm3, setDecm3] = useState("");
  const [decm6, setDecm6] = useState("");
  const [decm9, setDecm9] = useState("");
  const [decm1Comments, setDecm1Comments] = useState("");
  const [decm2Comments, setDecm2Comments] = useState("");
  const [decm3Comments, setDecm3Comments] = useState("");
  const [decm6Comments, setDecm6Comments] = useState("");
  const [decm9Comments, setDecm9Comments] = useState("");


  // DE AE
  const [deae2, setDeae2] = useState("");
  const [deae4, setDeae4] = useState("");
  const [deae3, setDeae3] = useState("");
  const [deae6, setDeae6] = useState("");
  const [deae7, setDeae7] = useState("");
  const [deae8, setDeae8] = useState("");
  const [deae2Comments, setDeae2Comments] = useState("");
  const [deae3Comments, setDeae3Comments] = useState("");
  const [deae4Comments, setDeae4Comments] = useState("");
  const [deae6Comments, setDeae6Comments] = useState("");
  const [deae7Comments, setDeae7Comments] = useState("");
  const [deae8Comments, setDeae8Comments] = useState("");

  // RS MA
  const [rsma1, setRsma1] = useState("");
  const [rsma2, setRsma2] = useState("");
  const [rsma3, setRsma3] = useState("");
  const [rsma4, setRsma4] = useState("");
  const [rsma5, setRsma5] = useState("");
  const [rsma1Comments, setRsma1Comments] = useState("");
  const [rsma2Comments, setRsma2Comments] = useState("");
  const [rsma3Comments, setRsma3Comments] = useState("");
  const [rsma4Comments, setRsma4Comments] = useState("");
  const [rsma5Comments, setRsma5Comments] = useState("");


  // RS AN
  const [rsan3, setRsan3] = useState("");
  const [rsan6, setRsan6] = useState("");
  const [rsan7, setRsan7] = useState("");
  const [rsan8, setRsan8] = useState("");
  const [rsan3Comments, setRsan3Comments] = useState("");
  const [rsan6Comments, setRsan6Comments] = useState("");
  const [rsan7Comments, setRsan7Comments] = useState("");
  const [rsan8Comments, setRsan8Comments] = useState("");


  // RS CO
  const [rsco2, setRsco2] = useState("");
  const [rsco3, setRsco3] = useState("");
  const [rsco2Comments, setRsco2Comments] = useState("");
  const [rsco3Comments, setRsco3Comments] = useState("");

  // RS MI
  const [rsmi1, setRsmi1] = useState("");
  const [rsmi2, setRsmi2] = useState("");
  const [rsmi1Comments, setRsmi1Comments] = useState("");
  const [rsmi2Comments, setRsmi2Comments] = useState("");

  // RC RP
  const [rcrp1, setRcrp1] = useState("");
  const [rcrp2, setRcrp2] = useState("");
  const [rcrp3, setRcrp3] = useState("");
  const [rcrp4, setRcrp4] = useState("");
  const [rcrp5, setRcrp5] = useState("");
  const [rcrp6, setRcrp6] = useState("");
  const [rcrp1Comments, setRcrp1Comments] = useState("");
  const [rcrp2Comments, setRcrp2Comments] = useState("");
  const [rcrp3Comments, setRcrp3Comments] = useState("");
  const [rcrp4Comments, setRcrp4Comments] = useState("");
  const [rcrp5Comments, setRcrp5Comments] = useState("");
  const [rcrp6Comments, setRcrp6Comments] = useState("");

  // RC CO
  const [rcco3, setRcco3] = useState("");
  const [rcco4, setRcco4] = useState("");
  const [rcco3Comments, setRcco3Comments] = useState("");
  const [rcco4Comments, setRcco4Comments] = useState("");

  // **************Category Scores for RadarChart
  const [gvScoreTotal, setGvScoreTotal] = useState(0);
  const [idScoreTotal, setIdScoreTotal] = useState(0);
  const [prScoreTotal, setPrScoreTotal] = useState(0);
  const [deScoreTotal, setDeScoreTotal] = useState(0);
  const [rsScoreTotal, setRsScoreTotal] = useState(0);
  const [rcScoreTotal, setRcScoreTotal] = useState(0);
  
  const [activeFunction, setActiveFunction] = useState(0);
  const [activeStep, setActiveStep] = React.useState(0);

  const variablesList = [ 
    gvoc1, gvoc2, gvoc3, gvoc4, gvoc5,
    gvrm1, gvrm2, gvrm3, gvrm4, gvrm5, gvrm6, gvrm7,
    gvrr1, gvrr2, gvrr3, gvrr4, 
    gvpo1, gvpo2, 
    gvov1, gvov2, gvov3,
    gvsc1, gvsc2, gvsc3, gvsc4, gvsc5, gvsc6, gvsc7, gvsc8, gvsc9, gvsc10,
    idam1, idam2, idam3, idam4, idam5, idam7, idam8, 
    idra1, idra2, idra3, idra4, idra5, idra6, idra7, idra8, idra9, idra10,
    idim1, idim2, idim3, idim4, 
    praa1, praa2, praa3, praa4, praa5, praa6,
    prat1, prat2, 
    prds1, prds2, prds10, prds11,
    prps1, prps2, prps3, prps4, prps5, prps6, 
    prir1, prir2, prir3, prir4, 
    decm1, decm2, decm3, decm6, decm9, 
    deae2, deae3, deae4, deae6, deae7, deae8, 
    rsma1, rsma2, rsma3, rsma4, rsma5, 
    rsan3, rsan6, rsan7, rsan8, 
    rsco2, rsco3,     
    rsmi1, rsmi2,
    rcrp1, rcrp2, rcrp3, rcrp4, rcrp5, rcrp6,
    rcco3, rcco4,
   ];
  
  const setVariableList = [ 
    setGvoc1, setGvoc2, setGvoc3, setGvoc4, setGvoc5,
    setGvrm1, setGvrm2, setGvrm3, setGvrm4, setGvrm5, setGvrm6, setGvrm7,
    setGvrr1, setGvrr2, setGvrr3, setGvrr4, 
    setGvpo1, setGvpo2,
    setGvov1, setGvov2, setGvov3,
    setGvsc1, setGvsc2, setGvsc3, setGvsc4, setGvsc5, setGvsc6, setGvsc7, setGvsc8, setGvsc9, setGvsc10,
    setIdam1, setIdam2, setIdam3, setIdam4, setIdam5, setIdam7, setIdam8,
    setIdra1, setIdra2, setIdra3, setIdra4, setIdra5, setIdra6, setIdra7, setIdra8, setIdra9, setIdra10,
    setIdim1, setIdim2, setIdim3, setIdim4, 
    setPraa1, setPraa2, setPraa3, setPraa4, setPraa5, setPraa6,
    setPrat1, setPrat2,
    setPrds1, setPrds2, setPrds10, setPrds11, //63
    setPrps1, setPrps2, setPrps3, setPrps4, setPrps5, setPrps6,
    setPrir1, setPrir2, setPrir3, setPrir4, 
    setDecm1, setDecm2, setDecm3, setDecm6, setDecm9,
    setDeae2, setDeae3, setDeae4, setDeae6, setDeae7, setDeae8,
    setRsma1, setRsma2, setRsma3, setRsma4, setRsma5,
    setRsan3, setRsan6, setRsan7, setRsan8,
    setRsco2, setRsco3,
    setRsmi1, setRsmi2,
    setRcrp1, setRcrp2, setRcrp3, setRcrp4, setRcrp5, setRcrp6,
    setRcco3, setRcco4
  
  ];
  
  const variablesCommentsList = [ 
    gvoc1Comments, gvoc2Comments, gvoc3Comments, gvoc4Comments, gvoc5Comments, 
    gvrm1Comments, gvrm2Comments, gvrm3Comments, gvrm4Comments, gvrm5Comments, gvrm6Comments, gvrm7Comments,
    gvrr1Comments, gvrr2Comments, gvrr3Comments, gvrr4Comments, 
    gvpo1Comments, gvpo2Comments, 
    gvov1Comments, gvov2Comments, gvov3Comments, 
    gvsc1Comments, gvsc2Comments, gvsc3Comments, gvsc4Comments, gvsc5Comments, gvsc6Comments, gvsc7Comments, gvsc8Comments, gvsc9Comments, gvsc10Comments,
    idam1Comments, idam2Comments, idam3Comments, idam4Comments, idam5Comments, idam7Comments, idam8Comments, 
    idra1Comments, idra2Comments, idra3Comments, idra4Comments, idra5Comments, idra6Comments, idra7Comments, idra8Comments, idra9Comments, idra10Comments,
    idim1Comments, idim2Comments, idim3Comments, idim4Comments, 
    praa1Comments, praa2Comments, praa3Comments, praa4Comments, praa5Comments, praa6Comments, 
    prat1Comments, prat2Comments, 
    prds1Comments, prds2Comments, prds10Comments, prds11Comments, 
    prps1Comments, prps2Comments, prps3Comments, prps4Comments, prps5Comments, prps6Comments, 
    prir1Comments, prir2Comments, prir3Comments, prir4Comments, 
    decm1Comments, decm2Comments, decm3Comments, decm6Comments, decm9Comments, 
    deae2Comments, deae3Comments, deae4Comments, deae6Comments, deae7Comments, deae8Comments, 
    rsma1Comments, rsma2Comments, rsma3Comments, rsma4Comments, rsma5Comments,
    rsan3Comments, rsan6Comments, rsan7Comments, rsan8Comments, 
    rsco2Comments, rsco3Comments, 
    rsmi1Comments, rsmi2Comments, 
    rcrp1Comments, rcrp2Comments, rcrp3Comments, rcrp4Comments, rcrp5Comments, rcrp6Comments,
    rcco3Comments, rcco4Comments,
  ];
  
  const setVariableCommentsList = [ 
    setGvoc1Comments, setGvoc2Comments, setGvoc3Comments, setGvoc4Comments, setGvoc5Comments, 
    setGvrm1Comments, setGvrm2Comments, setGvrm3Comments, setGvrm4Comments, setGvrm5Comments, setGvrm6Comments, setGvrm7Comments,
    setGvrr1Comments, setGvrr2Comments, setGvrr3Comments, setGvrr4Comments,  
    setGvpo1Comments, setGvpo2Comments,
    setGvov1Comments, setGvov2Comments, setGvov3Comments,
    setGvsc1Comments, setGvsc2Comments, setGvsc3Comments, setGvsc4Comments, setGvsc5Comments, setGvsc6Comments, setGvsc7Comments, setGvsc8Comments, setGvsc9Comments, setGvsc10Comments,
    setIdam1Comments, setIdam2Comments, setIdam3Comments, setIdam4Comments, setIdam5Comments, setIdam7Comments, setIdam8Comments,
    setIdra1Comments, setIdra2Comments, setIdra3Comments, setIdra4Comments, setIdra5Comments, setIdra6Comments, setIdra7Comments, setIdra8Comments, setIdra9Comments, setIdra10Comments,
    setIdim1Comments, setIdim2Comments, setIdim3Comments, setIdim4Comments,
    setPraa1Comments, setPraa2Comments, setPraa3Comments, setPraa4Comments, setPraa5Comments, setPraa6Comments,
    setPrat1Comments, setPrat2Comments,
    setPrds1Comments, setPrds2Comments, setPrds10Comments, setPrds11Comments, 
    setPrps1Comments, setPrps2Comments, setPrps3Comments, setPrps4Comments, setPrps5Comments, setPrps6Comments,
    setPrir1Comments, setPrir2Comments, setPrir3Comments, setPrir4Comments, 
    setDecm1Comments, setDecm2Comments, setDecm3Comments, setDecm6Comments, setDecm9Comments, 
    setDeae2Comments, setDeae3Comments, setDeae4Comments, setDeae6Comments, setDeae7Comments, setDeae8Comments,
    setRsma1Comments, setRsma2Comments, setRsma3Comments, setRsma4Comments, setRsma5Comments,
    setRsan3Comments, setRsan6Comments, setRsan7Comments, setRsan8Comments,
    setRsco2Comments, setRsco3Comments,
    setRsmi1Comments, setRsmi2Comments,
    setRcrp1Comments, setRcrp2Comments, setRcrp3Comments, setRcrp4Comments, setRcrp5Comments, setRcrp6Comments,
    setRcco3Comments, setRcco4Comments
  ];  
  
  // for testing REGEX search on db.
  // const [activeFunction, setActiveFunction] = useState("Govern (GV)");
  // const [activeStep, setActiveStep] = React.useState("Policy (PO)");


   // Get assessmnet data Function.  This should pull data for the assessment for the current assessment. 
   const getCSFQuestions = async () => {
    try {
      const response = await axiosPrivate.get(`/csfquestions`, {
          withCredentials: true
      });
      const data = await response.data;
      // console.log(data);
      setQuestions2(data);
  
    } catch (err) {
      // alert("Login Expired. access control");
      console.error(err);
      // navigate('/login', { state: { from: location }, replace: true });
    }
      
  };



  // Get assessmnet data Function.  This should pull data for the assessment for the current assessment. 
const getAssessmentData = async () => {
  try {
    const response = await axiosPrivate.get(`/csfassessments/data/${assessmentID}`, {
      withCredentials: true
    });
    const data = await response.data;

    // console.log(JSON.parse(data.assessmentAnswersData));

    setAllAssessmentData(JSON.parse(data.assessmentAnswersData));
    setGvoc1(JSON.parse(data.assessmentAnswersData).gvoc1);
    setGvoc2(JSON.parse(data.assessmentAnswersData).gvoc2);
    setGvoc3(JSON.parse(data.assessmentAnswersData).gvoc3);
    setGvoc4(JSON.parse(data.assessmentAnswersData).gvoc4);
    setGvoc5(JSON.parse(data.assessmentAnswersData).gvoc5);
    setGvrm1(JSON.parse(data.assessmentAnswersData).gvrm1);
    setGvrm2(JSON.parse(data.assessmentAnswersData).gvrm2);
    setGvrm3(JSON.parse(data.assessmentAnswersData).gvrm3);
    setGvrm4(JSON.parse(data.assessmentAnswersData).gvrm4);
    setGvrm5(JSON.parse(data.assessmentAnswersData).gvrm5);
    setGvrm6(JSON.parse(data.assessmentAnswersData).gvrm6);
    setGvrm7(JSON.parse(data.assessmentAnswersData).gvrm7);
    setGvrr1(JSON.parse(data.assessmentAnswersData).gvrr1);
    setGvrr2(JSON.parse(data.assessmentAnswersData).gvrr2);
    setGvrr3(JSON.parse(data.assessmentAnswersData).gvrr3);
    setGvrr4(JSON.parse(data.assessmentAnswersData).gvrr4);
    setGvpo1(JSON.parse(data.assessmentAnswersData).gvpo1);
    setGvpo2(JSON.parse(data.assessmentAnswersData).gvpo2);
    setGvov1(JSON.parse(data.assessmentAnswersData).gvov1);
    setGvov2(JSON.parse(data.assessmentAnswersData).gvov2);
    setGvov3(JSON.parse(data.assessmentAnswersData).gvov3);
    setGvsc1(JSON.parse(data.assessmentAnswersData).gvsc1);
    setGvsc2(JSON.parse(data.assessmentAnswersData).gvsc2);
    setGvsc3(JSON.parse(data.assessmentAnswersData).gvsc3);
    setGvsc4(JSON.parse(data.assessmentAnswersData).gvsc4);
    setGvsc5(JSON.parse(data.assessmentAnswersData).gvsc5);
    setGvsc6(JSON.parse(data.assessmentAnswersData).gvsc6);
    setGvsc7(JSON.parse(data.assessmentAnswersData).gvsc7);
    setGvsc8(JSON.parse(data.assessmentAnswersData).gvsc8);
    setGvsc9(JSON.parse(data.assessmentAnswersData).gvsc9);
    setGvsc10(JSON.parse(data.assessmentAnswersData).gvsc10);
    setIdam1(JSON.parse(data.assessmentAnswersData).idam1);
    setIdam2(JSON.parse(data.assessmentAnswersData).idam);
    setIdam3(JSON.parse(data.assessmentAnswersData).idam3);
    setIdam4(JSON.parse(data.assessmentAnswersData).idam4);
    setIdam5(JSON.parse(data.assessmentAnswersData).idam5);
    setIdam7(JSON.parse(data.assessmentAnswersData).idam7);
    setIdam8(JSON.parse(data.assessmentAnswersData).idam8);
    setIdra1(JSON.parse(data.assessmentAnswersData).idra1);
    setIdra2(JSON.parse(data.assessmentAnswersData).idra2);
    setIdra3(JSON.parse(data.assessmentAnswersData).idra3);
    setIdra4(JSON.parse(data.assessmentAnswersData).idra4);
    setIdra5(JSON.parse(data.assessmentAnswersData).idra5);
    setIdra6(JSON.parse(data.assessmentAnswersData).idra6);
    setIdra7(JSON.parse(data.assessmentAnswersData).idra7);
    setIdra8(JSON.parse(data.assessmentAnswersData).idra8);
    setIdra9(JSON.parse(data.assessmentAnswersData).idra9);
    setIdra10(JSON.parse(data.assessmentAnswersData).idra10);
    setIdim1(JSON.parse(data.assessmentAnswersData).idim1);
    setIdim2(JSON.parse(data.assessmentAnswersData).idim2);
    setIdim3(JSON.parse(data.assessmentAnswersData).idim3);
    setIdim4(JSON.parse(data.assessmentAnswersData).idim4);
    setPraa1(JSON.parse(data.assessmentAnswersData).praa1);
    setPraa2(JSON.parse(data.assessmentAnswersData).praa2);
    setPraa3(JSON.parse(data.assessmentAnswersData).praa3);
    setPraa4(JSON.parse(data.assessmentAnswersData).praa4);
    setPraa5(JSON.parse(data.assessmentAnswersData).praa5);
    setPraa6(JSON.parse(data.assessmentAnswersData).praa6);
    setPrat1(JSON.parse(data.assessmentAnswersData).prat1);
    setPrat2(JSON.parse(data.assessmentAnswersData).prat2);
    setPrds1(JSON.parse(data.assessmentAnswersData).prds1);
    setPrds2(JSON.parse(data.assessmentAnswersData).prds2);
    setPrds10(JSON.parse(data.assessmentAnswersData).prds10);
    setPrds11(JSON.parse(data.assessmentAnswersData).prds11);
    setPrps1(JSON.parse(data.assessmentAnswersData).prps1);
    setPrps2(JSON.parse(data.assessmentAnswersData).prps2);
    setPrps3(JSON.parse(data.assessmentAnswersData).prps3);
    setPrps4(JSON.parse(data.assessmentAnswersData).prps4);
    setPrps5(JSON.parse(data.assessmentAnswersData).prps5);
    setPrps6(JSON.parse(data.assessmentAnswersData).prps6);
    setPrir1(JSON.parse(data.assessmentAnswersData).prir1);
    setPrir2(JSON.parse(data.assessmentAnswersData).prir2);
    setPrir3(JSON.parse(data.assessmentAnswersData).prir3);
    setPrir4(JSON.parse(data.assessmentAnswersData).prir4);
    setDecm1(JSON.parse(data.assessmentAnswersData).decm1);
    setDecm2(JSON.parse(data.assessmentAnswersData).decm2);
    setDecm3(JSON.parse(data.assessmentAnswersData).decm3);
    setDecm6(JSON.parse(data.assessmentAnswersData).decm6);
    setDecm9(JSON.parse(data.assessmentAnswersData).decm9);
    setDeae2(JSON.parse(data.assessmentAnswersData).deae2);
    setDeae3(JSON.parse(data.assessmentAnswersData).deae3);
    setDeae4(JSON.parse(data.assessmentAnswersData).deae4);
    setDeae6(JSON.parse(data.assessmentAnswersData).deae6);
    setDeae7(JSON.parse(data.assessmentAnswersData).deae7);
    setDeae8(JSON.parse(data.assessmentAnswersData).deae8);
    setRsma1(JSON.parse(data.assessmentAnswersData).rsma1);
    setRsma2(JSON.parse(data.assessmentAnswersData).rsma2);
    setRsma3(JSON.parse(data.assessmentAnswersData).rsma3);
    setRsma4(JSON.parse(data.assessmentAnswersData).rsma4);
    setRsma5(JSON.parse(data.assessmentAnswersData).rsma5);
    setRsan3(JSON.parse(data.assessmentAnswersData).rsan3);
    setRsan6(JSON.parse(data.assessmentAnswersData).rsan6);
    setRsan7(JSON.parse(data.assessmentAnswersData).rsan7);
    setRsan8(JSON.parse(data.assessmentAnswersData).rsan8);
    setRsco2(JSON.parse(data.assessmentAnswersData).rsco2);
    setRsco3(JSON.parse(data.assessmentAnswersData).rsco3);
    setRsmi1(JSON.parse(data.assessmentAnswersData).rsmi1);
    setRsmi2(JSON.parse(data.assessmentAnswersData).rsmi2);
    setRcrp1(JSON.parse(data.assessmentAnswersData).rcrp1);
    setRcrp2(JSON.parse(data.assessmentAnswersData).rcrp2);
    setRcrp3(JSON.parse(data.assessmentAnswersData).rcrp3);
    setRcrp4(JSON.parse(data.assessmentAnswersData).rcrp4);
    setRcrp5(JSON.parse(data.assessmentAnswersData).rcrp5);
    setRcrp6(JSON.parse(data.assessmentAnswersData).rcrp6);
    setRcco3(JSON.parse(data.assessmentAnswersData).rcco3);
    setRcco4(JSON.parse(data.assessmentAnswersData).rcco4);
    setGvoc1Comments(JSON.parse(data.assessmentAnswersData).gvoc1Comments);
    setGvoc2Comments(JSON.parse(data.assessmentAnswersData).gvoc2Comments);
    setGvoc3Comments(JSON.parse(data.assessmentAnswersData).gvoc3Comments);
    setGvoc4Comments(JSON.parse(data.assessmentAnswersData).gvoc4Comments);
    setGvoc5Comments(JSON.parse(data.assessmentAnswersData).gvoc5Comments);
    setGvrm1Comments(JSON.parse(data.assessmentAnswersData).gvrm1Comments);
    setGvrm2Comments(JSON.parse(data.assessmentAnswersData).gvrm2Comments);
    setGvrm3Comments(JSON.parse(data.assessmentAnswersData).gvrm3Comments);
    setGvrm4Comments(JSON.parse(data.assessmentAnswersData).gvrm4Comments);
    setGvrm5Comments(JSON.parse(data.assessmentAnswersData).gvrm5Comments);
    setGvrm6Comments(JSON.parse(data.assessmentAnswersData).gvrm6Comments);
    setGvrm7Comments(JSON.parse(data.assessmentAnswersData).gvrm7Comments);
    setGvrr1Comments(JSON.parse(data.assessmentAnswersData).gvrr1Comments);
    setGvrr2Comments(JSON.parse(data.assessmentAnswersData).gvrr2Comments);
    setGvrr3Comments(JSON.parse(data.assessmentAnswersData).gvrr3Comments);
    setGvrr4Comments(JSON.parse(data.assessmentAnswersData).gvrr4Comments);
    setGvpo1Comments(JSON.parse(data.assessmentAnswersData).gvpo1Comments);
    setGvpo2Comments(JSON.parse(data.assessmentAnswersData).gvpo2Comments);
    setGvov1Comments(JSON.parse(data.assessmentAnswersData).gvov1Comments);
    setGvov2Comments(JSON.parse(data.assessmentAnswersData).gvov2Comments);
    setGvov3Comments(JSON.parse(data.assessmentAnswersData).gvov3Comments);
    setGvsc1Comments(JSON.parse(data.assessmentAnswersData).gvsc1Comments);
    setGvsc2Comments(JSON.parse(data.assessmentAnswersData).gvsc2Comments);
    setGvsc3Comments(JSON.parse(data.assessmentAnswersData).gvsc3Comments);
    setGvsc4Comments(JSON.parse(data.assessmentAnswersData).gvsc4Comments);
    setGvsc5Comments(JSON.parse(data.assessmentAnswersData).gvsc5Comments);
    setGvsc6Comments(JSON.parse(data.assessmentAnswersData).gvsc6Comments);
    setGvsc7Comments(JSON.parse(data.assessmentAnswersData).gvsc7Comments);
    setGvsc8Comments(JSON.parse(data.assessmentAnswersData).gvsc8Comments);
    setGvsc9Comments(JSON.parse(data.assessmentAnswersData).gvsc9Comments);
    setGvsc10Comments(JSON.parse(data.assessmentAnswersData).gvsc10Comments);
    setIdam1Comments(JSON.parse(data.assessmentAnswersData).idam1Comments);
    setIdam2Comments(JSON.parse(data.assessmentAnswersData).idam2Comments);
    setIdam3Comments(JSON.parse(data.assessmentAnswersData).idam3Comments);
    setIdam4Comments(JSON.parse(data.assessmentAnswersData).idam4Comments);
    setIdam5Comments(JSON.parse(data.assessmentAnswersData).idam5Comments);
    setIdam7Comments(JSON.parse(data.assessmentAnswersData).idam7Comments);
    setIdam8Comments(JSON.parse(data.assessmentAnswersData).idam8Comments);
    setIdra1Comments(JSON.parse(data.assessmentAnswersData).idra1Comments);
    setIdra2Comments(JSON.parse(data.assessmentAnswersData).idra2Comments);
    setIdra3Comments(JSON.parse(data.assessmentAnswersData).idra3Comments);
    setIdra4Comments(JSON.parse(data.assessmentAnswersData).idra4Comments);
    setIdra5Comments(JSON.parse(data.assessmentAnswersData).idra5Comments);
    setIdra6Comments(JSON.parse(data.assessmentAnswersData).idra6Comments);
    setIdra7Comments(JSON.parse(data.assessmentAnswersData).idra7Comments);
    setIdra8Comments(JSON.parse(data.assessmentAnswersData).idra8Comments);
    setIdra9Comments(JSON.parse(data.assessmentAnswersData).idra9Comments);
    setIdra10Comments(JSON.parse(data.assessmentAnswersData).idra10Comments);
    setIdim1Comments(JSON.parse(data.assessmentAnswersData).idim1Comments);
    setIdim2Comments(JSON.parse(data.assessmentAnswersData).idim2Comments);
    setIdim3Comments(JSON.parse(data.assessmentAnswersData).idim3Comments);
    setIdim4Comments(JSON.parse(data.assessmentAnswersData).idim4Comments);
    setPraa1Comments(JSON.parse(data.assessmentAnswersData).praa1Comments);
    setPraa2Comments(JSON.parse(data.assessmentAnswersData).praa2Comments);
    setPraa3Comments(JSON.parse(data.assessmentAnswersData).praa3Comments);
    setPraa4Comments(JSON.parse(data.assessmentAnswersData).praa4Comments);
    setPraa5Comments(JSON.parse(data.assessmentAnswersData).praa5Comments);
    setPraa6Comments(JSON.parse(data.assessmentAnswersData).praa6Comments);
    setPrat1Comments(JSON.parse(data.assessmentAnswersData).prat1Comments);
    setPrat2Comments(JSON.parse(data.assessmentAnswersData).prat2Comments);
    setPrds1Comments(JSON.parse(data.assessmentAnswersData).prds1Comments);
    setPrds2Comments(JSON.parse(data.assessmentAnswersData).prds2Comments);
    setPrds10Comments(JSON.parse(data.assessmentAnswersData).prds10Comments);
    setPrds11Comments(JSON.parse(data.assessmentAnswersData).prds11Comments);
    setPrps1Comments(JSON.parse(data.assessmentAnswersData).prps1Comments);
    setPrps2Comments(JSON.parse(data.assessmentAnswersData).prps2Comments);
    setPrps3Comments(JSON.parse(data.assessmentAnswersData).prps3Comments);
    setPrps4Comments(JSON.parse(data.assessmentAnswersData).prps4Comments);
    setPrps5Comments(JSON.parse(data.assessmentAnswersData).prps5Comments);
    setPrps6Comments(JSON.parse(data.assessmentAnswersData).prps6Comments);
    setPrir1Comments(JSON.parse(data.assessmentAnswersData).prir1Comments); 
    setPrir2Comments(JSON.parse(data.assessmentAnswersData).prir2Comments);
    setPrir3Comments(JSON.parse(data.assessmentAnswersData).prir3Comments);
    setPrir4Comments(JSON.parse(data.assessmentAnswersData).prir4Comments);
    setDecm1Comments(JSON.parse(data.assessmentAnswersData).decm1Comments);
    setDecm2Comments(JSON.parse(data.assessmentAnswersData).decm2Comments);
    setDecm3Comments(JSON.parse(data.assessmentAnswersData).decm3Comments);
    setDecm6Comments(JSON.parse(data.assessmentAnswersData).decm6Comments);
    setDecm9Comments(JSON.parse(data.assessmentAnswersData).decm9Comments);
    setDeae2Comments(JSON.parse(data.assessmentAnswersData).deae2Comments);
    setDeae3Comments(JSON.parse(data.assessmentAnswersData).deae3Comments);
    setDeae4Comments(JSON.parse(data.assessmentAnswersData).deae4Comments);
    setDeae6Comments(JSON.parse(data.assessmentAnswersData).deae6Comments);
    setDeae7Comments(JSON.parse(data.assessmentAnswersData).deae7Comments);
    setDeae8Comments(JSON.parse(data.assessmentAnswersData).deae8Comments);
    setRsma1Comments(JSON.parse(data.assessmentAnswersData).rsma1Comments);
    setRsma2Comments(JSON.parse(data.assessmentAnswersData).rsma2Comments);
    setRsma3Comments(JSON.parse(data.assessmentAnswersData).rsma3Comments);
    setRsma4Comments(JSON.parse(data.assessmentAnswersData).rsma4Comments);
    setRsma5Comments(JSON.parse(data.assessmentAnswersData).rsma5Comments);
    setRsan3Comments(JSON.parse(data.assessmentAnswersData).rsan3Comments);
    setRsan6Comments(JSON.parse(data.assessmentAnswersData).rsan6Comments);
    setRsan7Comments(JSON.parse(data.assessmentAnswersData).rsan7Comments);
    setRsan8Comments(JSON.parse(data.assessmentAnswersData).rsan8Comments);
    setRsco2Comments(JSON.parse(data.assessmentAnswersData).rsco2Comments);
    setRsco3Comments(JSON.parse(data.assessmentAnswersData).rsco3Comments);
    setRsmi1Comments(JSON.parse(data.assessmentAnswersData).rsmi1Comments);
    setRsmi2Comments(JSON.parse(data.assessmentAnswersData).rsmi2Comments);
    setRcrp1Comments(JSON.parse(data.assessmentAnswersData).rcrp1Comments);
    setRcrp2Comments(JSON.parse(data.assessmentAnswersData).rcrp2Comments); 
    setRcrp3Comments(JSON.parse(data.assessmentAnswersData).rcrp3Comments);
    setRcrp4Comments(JSON.parse(data.assessmentAnswersData).rcrp4Comments);
    setRcrp5Comments(JSON.parse(data.assessmentAnswersData).rcrp5Comments);
    setRcrp6Comments(JSON.parse(data.assessmentAnswersData).rcrp6Comments);
    setRcco3Comments(JSON.parse(data.assessmentAnswersData).rcco3Comments);
    setRcco4Comments(JSON.parse(data.assessmentAnswersData).rcco4Comments);
    setGvScoreTotal(JSON.parse(data.assessmentAnswersData).gvScoreTotal);
    setIdScoreTotal(JSON.parse(data.assessmentAnswersData).idScoreTotal);
    setPrScoreTotal(JSON.parse(data.assessmentAnswersData).prScoreTotal);
    setDeScoreTotal(JSON.parse(data.assessmentAnswersData).deScoreTotal);
    setRsScoreTotal(JSON.parse(data.assessmentAnswersData).rsScoreTotal);
    setRcScoreTotal(JSON.parse(data.assessmentAnswersData).rcScoreTotal);


  } catch (err) {
    // alert("Login Expirsed.");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
};

const handleNext = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth', // Enables smooth scrolling
  });
  if (activeFunction === 0 && activeStep <= 4 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 0 && activeStep === 5 ) {
    getResults();
    Scores();
    setActiveFunction(activeFunction+1);
    setActiveStep(0);
  };
  if (activeFunction === 1 && activeStep <= 1 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 1 && activeStep === 2 ) {
    getResults();
    Scores();
    setActiveFunction(activeFunction+1);
    setActiveStep(0);
  };
  if (activeFunction === 2 && activeStep <= 3 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 2 && activeStep === 4 ) {
    getResults();
    Scores();
    setActiveFunction(activeFunction+1);
    setActiveStep(0);
  };
  if (activeFunction === 3 && activeStep <= 0 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 3 && activeStep === 1 ) {
    getResults();
    Scores();
    setActiveFunction(activeFunction+1);
    setActiveStep(0);
  };
  if (activeFunction === 4 && activeStep <= 2 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 4 && activeStep === 3 ) {
    getResults();
    Scores();
    setActiveFunction(activeFunction+1);
    setActiveStep(0);
  };
  if (activeFunction === 5 && activeStep <= 0 ) {
    getResults();
    Scores();
    setActiveStep(activeStep+1);
  };
  if (activeFunction === 5 && activeStep === 1 ) {
    getResults();
    Scores();
    setActiveFunction(6);
  };

}
  
const Scores = () => {
    
  let tempGV = 0;
  let tempID = 0;
  let tempPR = 0;
  let tempDE = 0;
  let tempRS = 0;
  let tempRC = 0;
  
  let GVScores = [gvoc1, gvoc2, gvoc3, gvoc4, gvoc5,
    gvrm1, gvrm2, gvrm3, gvrm4, gvrm5, gvrm6, gvrm7,
    gvrr1, gvrr2, gvrr3, gvrr4, 
    gvpo1, gvpo2, 
    gvov1, gvov2, gvov3,
    gvsc1, gvsc2, gvsc3, gvsc4, gvsc5, gvsc6, gvsc7, gvsc8, gvsc9, gvsc10];

  let IDScores = [idam1, idam2, idam3, idam4, idam5, idam7, idam8, 
    idra1, idra2, idra3, idra4, idra5, idra6, idra7, idra8, idra9, idra10,
    idim1, idim2, idim3, idim4 ];

  let PRScores = [praa1, praa2, praa3, praa4, praa5, praa6,
    prat1, prat2, 
    prds1, prds2, prds10, prds11,
    prps1, prps2, prps3, prps4, prps5, prps6, 
    prir1, prir2, prir3, prir4 ];

  let DEScores = [decm1, decm2, decm3, decm6, decm9, 
    deae2, deae3, deae4, deae6, deae7, deae8 ];

  let RSScores = [rsma1, rsma2, rsma3, rsma4, rsma5, 
    rsan3, rsan6, rsan7, rsan8, 
    rsco2, rsco3,     
    rsmi1, rsmi2];

  let RCScores = [rcrp1, rcrp2, rcrp3, rcrp4, rcrp5, rcrp6,
    rcco3, rcco4]

  const ConvertToNumber = (score) => {
    if (score===null) return 0;
    if (score==="Partial")  {
        return 1;
    } else if (score==="Informed") {
         return 2;
    } else if (score==="Repeatable") {
        return 3;
    } else if (score==="Adaptive") {
        return 4;
    } else if (score==="na") {
        return 0;
    } else return 0;
  }

  for (let score in GVScores) {
    tempGV = tempGV + ConvertToNumber(GVScores[score]);
    // console.log(score);
    // console.log(GVScores[score]);
    // console.log(ConvertToNumber(GVScores[score]));
  };

  for (let score in IDScores) {
    tempID = tempID + ConvertToNumber(IDScores[score]);
    console.log(score);
    console.log(IDScores[score]);
    console.log(ConvertToNumber(IDScores[score]));
    
  };
  console.log(tempID);

  for (let score in PRScores) {
    tempPR = tempPR + ConvertToNumber(PRScores[score]);
  };
  for (let score in DEScores) {
    tempDE = tempDE + ConvertToNumber(DEScores[score]);
  };

  for (let score in RSScores) {
    tempRS = tempRS + ConvertToNumber(RSScores[score]);
  };

  for (let score in RCScores) {
    tempRC = tempRC + ConvertToNumber(RCScores[score]);
  };

  
  setGvScoreTotal(tempGV);
  setIdScoreTotal(tempID);
  setPrScoreTotal(tempPR);
  setDeScoreTotal(tempDE);
  setRsScoreTotal(tempRS);
  setRcScoreTotal(tempRC);
};

// *************** Update to use Questionnaire specific Variables***************//
const handleSubmit = async (e) => {
  e.preventDefault();
  const assessmentAnswersData = JSON.stringify({
    gvoc1, gvoc2, gvoc3, gvoc4, gvoc5,
    gvrm1, gvrm2, gvrm3, gvrm4, gvrm5, gvrm6, gvrm7,
    gvrr1, gvrr2, gvrr3, gvrr4, 
    gvpo1, gvpo2, 
    gvov1, gvov2, gvov3,
    gvsc1, gvsc2, gvsc3, gvsc4, gvsc5, gvsc6, gvsc7, gvsc8, gvsc9, gvsc10,
    idam1, idam2, idam3, idam4, idam5, idam7, idam8, 
    idra1, idra2, idra3, idra4, idra5, idra6, idra7, idra8, idra9, idra10,
    idim1, idim2, idim3, idim4, 
    praa1, praa2, praa3, praa4, praa5, praa6,
    prat1, prat2, 
    prds1, prds2, prds10, prds11,
    prps1, prps2, prps3, prps4, prps5, prps6, 
    prir1, prir2, prir3, prir4, 
    decm1, decm2, decm3, decm6, decm9, 
    deae2, deae3, deae4, deae6, deae7, deae8, 
    rsma1, rsma2, rsma3, rsma4, rsma5, 
    rsan3, rsan6, rsan7, rsan8, 
    rsco2, rsco3,     
    rsmi1, rsmi2,
    rcrp1, rcrp2, rcrp3, rcrp4, rcrp5, rcrp6,
    rcco3, rcco4,
    gvoc1Comments, gvoc2Comments, gvoc3Comments, gvoc4Comments, gvoc5Comments, 
    gvrm1Comments, gvrm2Comments, gvrm3Comments, gvrm4Comments, gvrm5Comments, gvrm6Comments, gvrm7Comments,
    gvrr1Comments, gvrr2Comments, gvrr3Comments, gvrr4Comments, 
    gvpo1Comments, gvpo2Comments, 
    gvov1Comments, gvov2Comments, gvov3Comments, 
    gvsc1Comments, gvsc2Comments, gvsc3Comments, gvsc4Comments, gvsc5Comments, gvsc6Comments, gvsc7Comments, gvsc8Comments, gvsc9Comments, gvsc10Comments,
    idam1Comments, idam2Comments, idam3Comments, idam4Comments, idam5Comments, idam7Comments, idam8Comments, 
    idra1Comments, idra2Comments, idra3Comments, idra4Comments, idra5Comments, idra6Comments, idra7Comments, idra8Comments, idra9Comments, idra10Comments,
    idim1Comments, idim2Comments, idim3Comments, idim4Comments, 
    praa1Comments, praa2Comments, praa3Comments, praa4Comments, praa5Comments, praa6Comments, 
    prat1Comments, prat2Comments, 
    prds1Comments, prds2Comments, prds10Comments, prds11Comments, 
    prps1Comments, prps2Comments, prps3Comments, prps4Comments, prps5Comments, prps6Comments, 
    prir1Comments, prir2Comments, prir3Comments, prir4Comments, 
    decm1Comments, decm2Comments, decm3Comments, decm6Comments, decm9Comments, 
    deae2Comments, deae3Comments, deae4Comments, deae6Comments, deae7Comments, deae8Comments, 
    rsma1Comments, rsma2Comments, rsma3Comments, rsma4Comments, rsma5Comments,
    rsan3Comments, rsan6Comments, rsan7Comments, rsan8Comments, 
    rsco2Comments, rsco3Comments, 
    rsmi1Comments, rsmi2Comments, 
    rcrp1Comments, rcrp2Comments, rcrp3Comments, rcrp4Comments, rcrp5Comments, rcrp6Comments,
    rcco3Comments, rcco4Comments,
    gvScoreTotal, idScoreTotal, prScoreTotal, deScoreTotal, rsScoreTotal, rcScoreTotal
  });

  try {
      const response = await axiosPrivate.patch(`/csfassessments/${assessmentID}`,
      JSON.stringify({ assessmentAnswersData }),
      {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true
      }
  );
  // questionFamily(1) activates the Access Control questions. 
  handleNext();
  window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  } catch (err) {
      if (!err?.response) {
          console.log('No Server Response');
      } else {
          console.log(err)
      }
  }
}

useEffect(() => {
  getCSFQuestions();
  // getAllCSFQuestions();
  getAssessmentData();
  Scores();
  // createList(activeFunction, activeStep);
}, []);  // eslint-disable-line react-hooks/exhaustive-deps
if (!questions2) {
  return null;
}


const GridItemQuestionXS = 12;
const GridItemInputXS = 11;
const GridItemInputSX = 'center';
const inputStyleWidth = '22px';
const inputStyleHeight = '22px';
const GridItemCommentsXS = 12;
const inputCommentWidth = '80%';
const checkboxMarginLeft = '80%';
const GridItemCheckboxContainerInputXS = 12;

  // CSF Questions

const questions = [
      // **********GOVERN (GV)********
      {
        function: 'Govern (GV)',
        functionDescription: 'The organization’s cybersecurity risk management strategy, expectations, and policy are established, communicated, and monitored',
        categories: [
          // ********Govern Organization Context Questions*************** 
          {
            category: 'Organizational Context (OC)',
              categoryDescription: 'The circumstances — mission, stakeholder expectations, dependencies, and legal, regulatory, and contractual requirements — surrounding the organization’s cybersecurity risk management decisions are understood',
              
              subcategories: [
                {
                  uid: 'GV.OC-01',
                  variable: gvoc1,
                  questionNumber: '1',
                  questionText: 'The organizational mission is understood and informs cybersecurity risk management.',
                  valueHelpText: [
                    'Ex1:  Share the organization’s mission (e.g., through vision and mission statements, marketing, and service strategies) to provide a basis for identifying risks that may impede that mission',
                  ],
                  name: 'NAME',
                  type: 'radiogroup',
                  checkboxInputs: [],
                  answerType: '',
                  commnets: 'true',
                  idComment: 'GV.OC-01COMMENT',
                  onChangeInput: setGvoc1,
                  valueComment: gvoc1Comments,
                  onChangeComments: setGvoc1Comments,
                  radiogroupInputs: [{
                    name: 'Partial', 
                    value: 0,
                    variable: gvoc1,
                    onChangeInput: setGvoc1,
                    title: 'Partial 1'
                  },
                  {
                    name: 'Informed', 
                    value: 1,
                    variable: gvoc1,
                    onChangeInput: setGvoc1,
                    title: 'Partial 1'
                  },
                  {
                    name: 'Repeatable', 
                    value: 2,
                    variable: gvoc1,
                    onChangeInput: setGvoc1,
                    title: 'Partial 1'
                  },
                  {
                    name: 'Adaptive',
                    value: 3,
                    variable: gvoc1,
                    onChangeInput: setGvoc1,
                    title: 'Partial 1'
                  }],
                  helpText: false
                },
                {
                  uid: 'GV.OC-02',
                  variable: gvoc2,
                  questionText: 'Internal and external stakeholders are understood, and their needs and expectations regarding cybersecurity risk management are understood and considered',
                  valueHelpText: [
                    'Ex1:  Identify relevant internal stakeholders and their cybersecurity-related expectations (e.g., performance and risk expectations of officers, directors, and advisors; cultural expectations of employees)',
                    'Ex2:  Identify relevant external stakeholders and their cybersecurity-related expectations (e.g., privacy expectations of customers, business expectations of partnerships, compliance expectations of regulators, ethics expectations of society)'
                  ],
                  onChangeInput: setGvoc2,
                  valueComment: gvoc2Comments,
                  onChangeComments: setGvoc2Comments,
                },
                {
                  uid: 'GV.OC-03',
                  variable: gvoc3,
                  questionText: 'Legal, regulatory, and contractual requirements regarding cybersecurity — including privacy and civil liberties obligations — are understood and managed',
                  valueHelpText: [
                    'Ex1:  Determine a process to track and manage legal and regulatory requirements regarding protection of individuals’ information (e.g., Health Insurance Portability and Accountability Act, California Consumer Privacy Act, General Data Protection Regulation) ',
                    'Ex2:  Determine a process to track and manage contractual requirements for cybersecurity management of supplier, customer, and partner information',
                    'Ex3:  Align the organization’s cybersecurity strategy with legal, regulatory, and contractual requirements'
                  ],
                  onChangeInput: setGvoc3,
                  valueComment: gvoc3Comments,
                  onChangeComments: setGvoc3Comments,
                },
                {
                  uid: 'GV.OC-04',
                  variable: gvoc4,
                  questionText: 'Critical objectives, capabilities, and services that stakeholders depend on or expect from the organization are understood and communicated',
                  valueHelpText: [
                    'Ex1:  Establish criteria for determining the criticality of capabilities and services as viewed by internal and external stakeholders',
                    'Ex2:  Determine (e.g., from a business impact analysis) assets and business operations that are vital to achieving mission objectives and the potential impact of a loss (or partial loss) of such operations ',
                    'Ex3:  Establish and communicate resilience objectives (e.g., recovery time objectives) for delivering critical capabilities and services in various operating states (e.g., under attack, during recovery, normal operation)'
                  ],
                  onChangeInput: setGvoc4,
                  valueComment: gvoc4Comments,
                  onChangeComments: setGvoc4Comments,
                },
                {
                  uid: 'GV.OC-05',
                  variable: gvoc5,
                  questionText: 'Outcomes, capabilities, and services that the organization depends on are understood and communicated',
                  valueHelpText: [
                    'Ex1:  Create an inventory of the organization’s dependencies on external resources (e.g., facilities, cloud-based hosting providers) and their relationships to organizational assets and business functions',
                    'Ex2:  Identify and document external dependencies that are potential points of failure for the organization’s critical capabilities and services, and share that information with appropriate personnel'
                  ],
                  onChangeInput: setGvoc5,
                  valueComment: gvoc5Comments,
                  onChangeComments: setGvoc5Comments,
                }

              ],

          },
          // ********Govern Risk Management Questions*************** 
          {
            category: 'Risk Management (RM)',
            categoryDescription: 'The organization’s priorities, constraints, risk tolerance and appetite statements, and assumptions are established, communicated, and used to support operational risk decisions',
              // ********Function Category Questions***************
              subcategories: [
                {
                  uid: 'GV.RM-01',
                  variable: gvrm1,
                  questionText: 'Inventories of hardware managed by the organization are maintained',
                  valueHelpText: [
                    'Ex1:  Maintain inventories for all types of hardware, including IT, IoT, OT, and mobile devices',
                    'Ex2:  Constantly monitor networks to detect new hardware and automatically update inventories'
                  ],
                  onChangeInput: setGvrm1,
                  valueComment: gvrm1Comments,
                  onChangeComments: setGvrm1Comments,
                },
                {
                  uid: 'GV.RM-02',
                  variable: gvrm2,
                  questionText: 'Inventories of software, services, and systems managed by the organization are maintained',
                  valueHelpText: [
                    'Ex1:  Maintain inventories for all types of software and services, including commercial-off-the-shelf, open-source, custom applications, API services, and cloud-based applications and services ',
                    'Ex2:  Constantly monitor all platforms, including containers and virtual machines, for software and service inventory changes',
                    'Ex3:  Maintain an inventory of the organization’s systems'
                  ],
                  onChangeInput: setGvrm2,
                  valueComment: gvrm2Comments,
                  onChangeComments: setGvrm2Comments,
                },
                {
                  uid: 'GV.RM-03',
                  questionText: 'Representations of the organization’s authorized network communication and internal and external network data flows are maintained',
                  variable: gvrm3,
                  valueHelpText: [
                    'Ex1:  Maintain baselines of communication and data flows within the organization’s wired and wireless networks ',
                    'Ex2:  Maintain baselines of communication and data flows between the organization and third parties ',
                    'Ex3:  Maintain baselines of communication and data flows for the organization’s infrastructure-as-a-service (IaaS) usage',
                    'Ex4:  Maintain documentation of expected network ports, protocols, and services that are typically used among authorized systems'
                  ],
                  onChangeInput: setGvrm3,
                  valueComment: gvrm3Comments,
                  onChangeComments: setGvrm3Comments,
                },
                {
                  uid: 'GV.RM-04',
                  questionText: 'Strategic direction that describes appropriate risk response options is established and communicated',
                  variable: gvrm4,
                  valueHelpText: [
                    'Ex1:  Specify criteria for accepting and avoiding cybersecurity risk for various classifications of data',
                    'Ex2:  Determine whether to purchase cybersecurity insurance',
                    'Ex3:  Document conditions under which shared responsibility models are acceptable (e.g., outsourcing certain cybersecurity functions, having a third party perform financial transactions on behalf of the organization, using public cloud-based services)'
                  ],
                  onChangeInput: setGvrm4,
                  valueComment: gvrm4Comments,
                  onChangeComments: setGvrm4Comments,
                },
                {
                  uid: 'GV.RM-05',
                  questionText: 'Lines of communication across the organization are established for cybersecurity risks, including risks from suppliers and other third parties',
                  variable: gvrm5,
                  valueHelpText: [
                    'Ex1:  Determine how to update senior executives, directors, and management on the organization’s cybersecurity posture at agreed-upon intervals ',
                    'Ex2:  Identify how all departments across the organization — such as management, operations, internal auditors, legal, acquisition, physical security, and HR — will communicate with each other about cybersecurity risks',
                  ],
                  onChangeInput: setGvrm5,
                  valueComment: gvrm5Comments,
                  onChangeComments: setGvrm5Comments,
                },
                {
                  uid: 'GV.RM-06',
                  questionText: 'A standardized method for calculating, documenting, categorizing, and prioritizing cybersecurity risks is established and communicated',
                  variable: gvrm6,
                  valueHelpText: [
                    'Ex1:  Establish criteria for using a quantitative approach to cybersecurity risk analysis, and specify probability and exposure formulas',
                    'Ex2:  Create and use templates (e.g., a risk register) to document cybersecurity risk information (e.g., risk description, exposure, treatment, and ownership)',
                    'Ex3:  Establish criteria for risk prioritization at the appropriate levels within the enterprise',
                    'Ex4:  Use a consistent list of risk categories to support integrating, aggregating, and comparing cybersecurity risks'
                  ],
                  onChangeInput: setGvrm6,
                  valueComment: gvrm6Comments,
                  onChangeComments: setGvrm6Comments,
                },
                {
                  uid: 'GV.RM-07',
                  questionText: 'Strategic opportunities (i.e., positive risks) are characterized and are included in organizational cybersecurity risk discussions',
                  variable: gvrm7,
                  valueHelpText: [
                    'Ex1:  Define and communicate guidance and methods for identifying opportunities and including them in risk discussions (e.g., strengths, weaknesses, opportunities, and threats [SWOT] analysis)',
                    'Ex2:  Identify stretch goals and document them',
                    'Ex3:  Calculate, document, and prioritize positive risks alongside negative risks'
                  ],
                  onChangeInput: setGvrm7,
                  valueComment: gvrm7Comments,
                  onChangeComments: setGvrm7Comments,
                }
              ]
          },
          // ********Govern Roles, Responsibilities, and Authorities Questions*************** 
          {
            category: 'Roles, Responsibilities, and Authorities (RR)',
            categoryDescription: 'Cybersecurity roles, responsibilities, and authorities to foster accountability, performance assessment, and continuous improvement are established and communicated',
            subcategories: [
              {
                uid: 'GV.RR-01',
                questionText: 'Organizational leadership is responsible and accountable for cybersecurity risk and fosters a culture that is risk-aware, ethical, and continually improving',
                variable: gvrr1,
                valueHelpText: [
                  'Ex1:  Leaders (e.g., directors) agree on their roles and responsibilities in developing, implementing, and assessing the organization’s cybersecurity strategy',
                  'Ex2:  Share leaders’ expectations regarding a secure and ethical culture, especially when current events present the opportunity to highlight positive or negative examples of cybersecurity risk management',
                  'Ex3:  Leaders direct the CISO to maintain a comprehensive cybersecurity risk strategy and review and update it at least annually and after major events',
                  'Ex4:  Conduct reviews to ensure adequate authority and coordination among those responsible for managing cybersecurity risk'
                ],
                onChangeInput: setGvrr1,
                valueComment: gvrr1Comments,
                onChangeComments: setGvrr1Comments
              },
              {
                uid: 'GV.RR-02',
                questionText: 'Roles, responsibilities, and authorities related to cybersecurity risk management are established, communicated, understood, and enforced',
                variable: gvrr2,
                valueHelpText: [
                  'Ex1:  Document risk management roles and responsibilities in policy',
                  'Ex2:  Document who is responsible and accountable for cybersecurity risk management activities and how those teams and individuals are to be consulted and informed',
                  'Ex3:  Include cybersecurity responsibilities and performance requirements in personnel descriptions',
                  'Ex4:  Document performance goals for personnel with cybersecurity risk management responsibilities, and periodically measure performance to identify areas for improvement',
                  'Ex5:  Clearly articulate cybersecurity responsibilities within operations, risk functions, and internal audit functions'
                ],
                onChangeInput: setGvrr2,
                valueComment: gvrr2Comments,
                onChangeComments: setGvrr2Comments
              },
              {
                uid: 'GV.RR-03',
                questionText: 'Adequate resources are allocated commensurate with the cybersecurity risk strategy, roles, responsibilities, and policies',
                variable: gvrr3,
                valueHelpText: [
                  'Ex1:  Conduct periodic management reviews to ensure that those given cybersecurity risk management responsibilities have the necessary authority ',
                  'Ex2:  Identify resource allocation and investment in line with risk tolerance and response ',
                  'Ex3:  Provide adequate and sufficient people, process, and technical resources to support the cybersecurity strategy'
                ],
                onChangeInput: setGvrr3,
                valueComment: gvrr3Comments,
                onChangeComments: setGvrr3Comments
              },
              {
                uid: 'GV.RR-04',
                questionText: 'Cybersecurity is included in human resources practices',
                variable: gvrr4, 
                valueHelpText: [
                  'Ex1:  Integrate cybersecurity risk management considerations into human resources processes (e.g., personnel screening, onboarding, change notification, offboarding) ',
                  'Ex2:  Consider cybersecurity knowledge to be a positive factor in hiring, training, and retention decisions',
                  'Ex3:  Conduct background checks prior to onboarding new personnel for sensitive roles, and periodically repeat background checks for personnel with such roles',
                  'Ex4:  Define and enforce obligations for personnel to be aware of, adhere to, and uphold security policies as they relate to their roles'
                ],
                onChangeInput: setGvrr4,
                valueComment: gvrr4Comments,
                onChangeComments: setGvrr4Comments
              },
            ]

          },
          // ********Govern Policy Questions*************** 
          {
            category: 'Policy (PO)',
            categoryDescription: '',
            subcategories: [
              {
                uid: 'GV.PO-01',
                questionText: 'Policy for managing cybersecurity risks is established based on organizational context, cybersecurity strategy, and priorities and is communicated and enforced',
                variable: gvpo1,
                valueHelpText: [
                  'Ex1:  Create, disseminate, and maintain an understandable, usable risk management policy with statements of management intent, expectations, and direction',
                  'Ex2:  Periodically review policy and supporting processes and procedures to ensure that they align with risk management strategy objectives and priorities, as well as the high-level direction of the cybersecurity policy',
                  'Ex3:  Require approval from senior management on policy',
                  'Ex4:  Communicate cybersecurity risk management policy and supporting processes and procedures across the organization',
                  'Ex5:  Require personnel to acknowledge receipt of policy when first hired, annually, and whenever policy is updated'
                ],
                onChangeInput: setGvpo1,
                valueComment: gvpo1Comments,
                onChangeComments: setGvpo1Comments
              },
              {
                uid: 'GV.PO-02',
                questionText: 'Policy for managing cybersecurity risks is reviewed, updated, communicated, and enforced to reflect changes in requirements, threats, technology, and organizational mission',
                variable: gvpo2,
                valueHelpText: [
                  'Ex1:  Update policy based on periodic reviews of cybersecurity risk management results to ensure that policy and supporting processes and procedures adequately maintain risk at an acceptable level',
                  'Ex2:  Provide a timeline for reviewing changes to the organization’s risk environment (e.g., changes in risk or in the organization’s mission objectives), and communicate recommended policy updates',
                  'Ex3:  Update policy to reflect changes in legal and regulatory requirements',
                  'Ex4:  Update policy to reflect changes in technology (e.g., adoption of artificial intelligence) and changes to the business (e.g., acquisition of a new business, new contract requirements)',
                ],
                onChangeInput: setGvpo2,
                valueComment: gvpo2Comments,
                onChangeComments: setGvpo2Comments
              },
            ]
          },

          // ********Govern Oversight Questions*************** 
          {
            category: 'Oversight (OV)',
            categoryDescription: '',
            subcategories: [
              {
                uid: 'GV.OV-01',
                questionText: ' Cybersecurity risk management strategy outcomes are reviewed to inform and adjust strategy and direction',
                variable: gvov1,
                valueHelpText: [
                  'Ex1:  Measure how well the risk management strategy and risk results have helped leaders make decisions and achieve organizational objectives',
                  'Ex2:  Examine whether cybersecurity risk strategies that impede operations or innovation should be adjusted'
                ],
                onChangeInput: setGvov1,
                valueComment: gvov1Comments,
                onChangeComments: setGvov1Comments
              },
              {
                uid: 'GV.OV-02',
                questionText: 'The cybersecurity risk management strategy is reviewed and adjusted to ensure coverage of organizational requirements and risks',
                variable: gvov2,
                valueHelpText: [
                  'Ex1:  Review audit findings to confirm whether the existing cybersecurity strategy has ensured compliance with internal and external requirements',
                  'Ex2:  Review the performance oversight of those in cybersecurity-related roles to determine whether policy changes are necessary',
                  'Ex3:  Review strategy in light of cybersecurity incidents '
                ],
                onChangeInput: setGvov2,
                valueComment: gvov2Comments,
                onChangeComments: setGvov2Comments
              },
              {
                uid: 'GV.OV-03',
                questionText: 'Organizational cybersecurity risk management performance is evaluated and reviewed for adjustments needed',
                variable: gvov3,
                valueHelpText: [
                  'Ex1:  Review key performance indicators (KPIs) to ensure that organization-wide policies and procedures achieve objectives',
                  'Ex2:  Review key risk indicators (KRIs) to identify risks the organization faces, including likelihood and potential impact',
                  'Ex3:  Collect and communicate metrics on cybersecurity risk management with senior leadership'
                ],
                onChangeInput: setGvov3,
                valueComment: gvov3Comments,
                onChangeComments: setGvov3Comments
              },
            ]
          },

          // ********Govern Supply Chain Risk Management Questions*************** 
          {
            category: 'Supply Chain Risk Management (SC)',
            categoryDescription: '',
            subcategories: [
              {
                uid: 'GV.SC-01',
                questionText: 'Policy for managing cybersecurity risks is established based on organizational context, cybersecurity strategy, and priorities and is communicated and enforced',
                variable: gvsc1,
                valueHelpText: [
                  'Ex1:  Create, disseminate, and maintain an understandable, usable risk management policy with statements of management intent, expectations, and direction',
                  'Ex2:  Periodically review policy and supporting processes and procedures to ensure that they align with risk management strategy objectives and priorities, as well as the high-level direction of the cybersecurity policy',
                  'Ex3:  Require approval from senior management on policy',
                  'Ex4:  Communicate cybersecurity risk management policy and supporting processes and procedures across the organization',
                  'Ex5:  Require personnel to acknowledge receipt of policy when first hired, annually, and whenever policy is updated'
                ],
                onChangeInput: setGvsc1,
                valueComment: gvsc1Comments,
                onChangeComments: setGvsc1Comments
              },
              {
                uid: 'GV.SC-02',
                questionText: 'Cybersecurity roles and responsibilities for suppliers, customers, and partners are established, communicated, and coordinated internally and externally',
                variable: gvsc2,
                valueHelpText: [
                  'Ex1:  Identify one or more specific roles or positions that will be responsible and accountable for planning, resourcing, and executing cybersecurity supply chain risk management activities',
                  'Ex2:  Document cybersecurity supply chain risk management roles and responsibilities in policy',
                  'Ex3: Create responsibility matrixes to document who will be responsible and accountable for cybersecurity supply chain risk management activities and how those teams and individuals will be consulted and informed ',
                  'Ex4:  Include cybersecurity supply chain risk management responsibilities and performance requirements in personnel descriptions to ensure clarity and improve accountability',
                  'Ex5:  Document performance goals for personnel with cybersecurity risk management-specific responsibilities, and periodically measure them to demonstrate and improve performance',
                  'Ex6:  Develop roles and responsibilities for suppliers, customers, and business partners to address shared responsibilities for applicable cybersecurity risks, and integrate them into organizational policies and applicable third-party agreements',
                  'Ex7:  Internally communicate cybersecurity supply chain risk management roles and responsibilities for third parties',
                  'Ex8:  Establish rules and protocols for information sharing and reporting processes between the organization and its suppliers'
                ],
                onChangeInput: setGvsc2,
                valueComment: gvsc2Comments,
                onChangeComments: setGvsc2Comments
              },
              {
                uid: 'GV.SC-03',
                questionText: 'Cybersecurity supply chain risk management is integrated into cybersecurity and enterprise risk management, risk assessment, and improvement processes',
                variable: gvsc3,
                valueHelpText: [
                  'Ex1:  Identify areas of alignment and overlap with cybersecurity and enterprise risk management',
                  'Ex2:  Establish integrated control sets for cybersecurity risk management and cybersecurity supply chain risk management',
                  'Ex3:  Integrate cybersecurity supply chain risk management into improvement processes',
                  'Ex4:  Escalate material cybersecurity risks in supply chains to senior management, and address them at the enterprise risk management level'
                ],
                onChangeInput: setGvsc3,
                valueComment: gvsc3Comments,
                onChangeComments: setGvsc3Comments
              },
              {
                uid: 'GV.SC-04',
                questionText: 'Suppliers are known and prioritized by criticality',
                variable: gvsc4,
                valueHelpText: [
                  'Ex1:  Develop criteria for supplier criticality based on, for example, the sensitivity of data processed or possessed by suppliers, the degree of access to the organization’s systems, and the importance of the products or services to the organization’s mission',
                  'Ex2:  Keep a record of all suppliers, and prioritize suppliers based on the criticality criteria',
                ],
                onChangeInput: setGvsc4,
                valueComment: gvsc4Comments,
                onChangeComments: setGvsc4Comments
              },
              {
                uid: 'GV.SC-05',
                questionText: 'Requirements to address cybersecurity risks in supply chains are established, prioritized, and integrated into contracts and other types of agreements with suppliers and other relevant third parties',
                variable: gvsc5,
                valueHelpText: [
                  'Ex1:  Establish security requirements for suppliers, products, and services commensurate with their criticality level and potential impact if compromised',
                  'Ex2:  Include all cybersecurity and supply chain requirements that third parties must follow and how compliance with the requirements may be verified in default contractual language',
                  'Ex3:  Define the rules and protocols for information sharing between the organization and its suppliers and sub-tier suppliers in agreements',
                  'Ex4:  Manage risk by including security requirements in agreements based on their criticality and potential impact if compromised',
                  'Ex5:  Define security requirements in service-level agreements (SLAs) for monitoring suppliers for acceptable security performance throughout the supplier relationship lifecycle',
                  'Ex6:  Contractually require suppliers to disclose cybersecurity features, functions, and vulnerabilities of their products and services for the life of the product or the term of service',
                  'Ex7:  Contractually require suppliers to provide and maintain a current component inventory (e.g., software or hardware bill of materials) for critical products',
                  'Ex8:  Contractually require suppliers to vet their employees and guard against insider threats',
                  'Ex9:  Contractually require suppliers to provide evidence of performing acceptable security practices through, for example, self-attestation, conformance to known standards, certifications, or inspections',
                  'Ex10:  Specify in contracts and other agreements the rights and responsibilities of the organization, its suppliers, and their supply chains, with respect to potential cybersecurity risks'
                ],
                onChangeInput: setGvsc5,
                valueComment: gvsc5Comments,
                onChangeComments: setGvsc5Comments
              },
              {
                uid: 'GV.SC-06',
                questionText: 'Planning and due diligence are performed to reduce risks before entering into formal supplier or other third-party relationships',
                variable: gvsc6,
                valueHelpText: [
                  'Ex1:  Perform thorough due diligence on prospective suppliers that is consistent with procurement planning and commensurate with the level of risk, criticality, and complexity of each supplier relationship',
                  'Ex2:  Assess the suitability of the technology and cybersecurity capabilities and the risk management practices of prospective suppliers',
                  'Ex3:  Conduct supplier risk assessments against business and applicable cybersecurity requirements',
                  'Ex4:  Assess the authenticity, integrity, and security of critical products prior to acquisition and use'
                ],
                onChangeInput: setGvsc6,
                valueComment: gvsc6Comments,
                onChangeComments: setGvsc6Comments
              },
              {
                uid: 'GV.SC-07',
                questionText: 'The risks posed by a supplier, their products and services, and other third parties are understood, recorded, prioritized, assessed, responded to, and monitored over the course of the relationship',
                variable: gvsc7,
                valueHelpText: [
                  'Ex1:  Adjust assessment formats and frequencies based on the third party’s reputation and the criticality of the products or services they provide',
                  'Ex2:  Evaluate third parties’ evidence of compliance with contractual cybersecurity requirements, such as self-attestations, warranties, certifications, and other artifacts',
                  'Ex3:  Monitor critical suppliers to ensure that they are fulfilling their security obligations throughout the supplier relationship lifecycle using a variety of methods and techniques, such as inspections, audits, tests, or other forms of evaluation',
                  'Ex4:  Monitor critical suppliers, services, and products for changes to their risk profiles, and reevaluate supplier criticality and risk impact accordingly',
                  'Ex5:  Plan for unexpected supplier and supply chain-related interruptions to ensure business continuity',
                  ''
                ],
                onChangeInput: setGvsc7,
                valueComment: gvsc7Comments,
                onChangeComments: setGvsc7Comments
              },
              {
                uid: 'GV.SC-08',
                questionText: 'Relevant suppliers and other third parties are included in incident planning, response, and recovery activities',
                variable: gvsc8,
                valueHelpText: [
                  'Ex1:  Define and use rules and protocols for reporting incident response and recovery activities and the status between the organization and its suppliers',
                  'Ex2:  Identify and document the roles and responsibilities of the organization and its suppliers for incident response',
                  'Ex3:  Include critical suppliers in incident response exercises and simulations',
                  'Ex4:  Define and coordinate crisis communication methods and protocols between the organization and its critical suppliers',
                  'Ex5:  Conduct collaborative lessons learned sessions with critical suppliers'
                ],
                onChangeInput: setGvsc8,
                valueComment: gvsc8Comments,
                onChangeComments: setGvsc8Comments
              },
              {
                uid: 'GV.SC-09',
                questionText: 'Supply chain security practices are integrated into cybersecurity and enterprise risk management programs, and their performance is monitored throughout the technology product and service life cycle',
                variable: gvsc9,
                valueHelpText: [
                  'Ex1:  Policies and procedures require provenance records for all acquired technology products and services',
                  'Ex2:  Periodically provide risk reporting to leaders about how acquired components are proven to be untampered and authentic',
                  'Ex3:  Communicate regularly among cybersecurity risk managers and operations personnel about the need to acquire software patches, updates, and upgrades only from authenticated and trustworthy software providers ',
                  'Ex4:  Review policies to ensure that they require approved supplier personnel to perform maintenance on supplier products',
                  'Ex5:  Policies and procedure require checking upgrades to critical hardware for unauthorized changes'
                ],
                onChangeInput: setGvsc9,
                valueComment: gvsc9Comments,
                onChangeComments: setGvsc9Comments
              },
              {
                uid: 'GV.SC-10',
                questionText: 'Cybersecurity supply chain risk management plans include provisions for activities that occur after the conclusion of a partnership or service agreement',
                variable: gvsc10,
                valueHelpText: [
                  'Ex1:  Establish processes for terminating critical relationships under both normal and adverse circumstances',
                  'Ex2:  Define and implement plans for component end-of-life maintenance support and obsolescence',
                  'Ex3:  Verify that supplier access to organization resources is deactivated promptly when it is no longer needed',
                  'Ex4:  Verify that assets containing the organization’s data are returned or properly disposed of in a timely, controlled, and safe manner',
                  'Ex5:  Develop and execute a plan for terminating or transitioning supplier relationships that takes supply chain security risk and resiliency into account',
                  'Ex6:  Mitigate risks to data and systems created by supplier termination',
                  'Ex7:  Manage data leakage risks associated with supplier termination'
                ],
                onChangeInput: setGvsc10,
                valueComment: gvsc10Comments,
                onChangeComments: setGvsc10Comments
              },
            ]
          },

        ]

      },
      // **********IDENTIFY (ID)********
      {
        function: 'Identify (ID)',
        functionDescription: 'The organization’s current cybersecurity risks are understood',
        categories: [
          {
            category: 'Asset Management (AM)',
            categoryDescription: 'Assets (e.g., data, hardware, software, systems, facilities, services, people) that enable the organization to achieve business purposes are identified and managed consistent with their relative importance to organizational objectives and the organization’s risk strategy',
              subcategories: [
                {
                  uid: 'ID.AM-01',
                  variable: idam1,
                  questionText: 'Inventories of hardware managed by the organization are maintained.',
                  valueHelpText: [
                    'Ex1:  Maintain inventories for all types of hardware, including IT, IoT, OT, and mobile devices',
                    'Ex2:  Constantly monitor networks to detect new hardware and automatically update inventories'
                  ],
                  onChangeInput: setIdam1,
                  valueComment: idam1Comments,
                  onChangeComments: setIdam1Comments,
                },
                {
                  uid: 'ID.AM-02',
                  variable: idam2,
                  questionText: 'Inventories of software, services, and systems managed by the organization are maintained',
                  valueHelpText: [
                    'Ex1:  Maintain inventories for all types of software and services, including commercial-off-the-shelf, open-source, custom applications, API services, and cloud-based applications and services ',
                    'Ex2:  Constantly monitor all platforms, including containers and virtual machines, for software and service inventory changes',
                    'Ex3:  Maintain an inventory of the organization’s systems'
                  ],
                  onChangeInput: setIdam2,
                  valueComment: idam2Comments,
                  onChangeComments: setIdam2Comments,
                },
                {
                  uid: 'ID.AM-03',
                  variable: idam3,
                  questionText: 'Representations of the organization’s authorized network communication and internal and external network data flows are maintained',
                  valueHelpText: [
                    'Ex1:  Maintain baselines of communication and data flows within the organization’s wired and wireless networks ',
                    'Ex2:  Maintain baselines of communication and data flows between the organization and third parties ',
                    'Ex3: Maintain baselines of communication and data flows for the organization’s infrastructure-as-a-service (IaaS) usage',
                    'Ex4:  Maintain documentation of expected network ports, protocols, and services that are typically used among authorized systems'
                  ],
                  onChangeInput: setIdam3,
                  valueComment: idam3Comments,
                  onChangeComments: setIdam3Comments,
                },
                {
                  uid: 'ID.AM-04',
                  variable: idam4,
                  questionText: 'Inventories of services provided by suppliers are maintained',
                  valueHelpText: [
                    'Ex1:  Inventory all external services used by the organization, including third-party infrastructure-as-a-service (IaaS), platform-as-a-service (PaaS), and software-as-a-service (SaaS) offerings; APIs; and other externally hosted application services',
                    'Ex2:  Update the inventory when a new external service is going to be utilized to ensure adequate cybersecurity risk management monitoring of the organization’s use of that service',
                  ],
                  onChangeInput: setIdam4,
                  valueComment: idam4Comments,
                  onChangeComments: setIdam4Comments,
                },
                {
                  uid: 'ID.AM-05',
                  variable: idam5,
                  questionText: 'Assets are prioritized based on classification, criticality, resources, and impact on the mission',
                  valueHelpText: [
                    'Ex1:  Define criteria for prioritizing each class of assets',
                    'Ex2:  Apply the prioritization criteria to assets',
                    'Ex3:  Track the asset priorities and update them periodically or when significant changes to the organization occur'
                  ],
                  onChangeInput: setIdam5,
                  valueComment: idam5Comments,
                  onChangeComments: setIdam5Comments,
                },
                {
                  uid: 'ID.AM-07',
                  variable: idam7,
                  questionText: 'Inventories of data and corresponding metadata for designated data types are maintained',
                  valueHelpText: [
                    'Ex1:  Maintain a list of the designated data types of interest (e.g., personally identifiable information, protected health information, financial account numbers, organization intellectual property, operational technology data)',
                    'Ex2:  Continuously discover and analyze ad hoc data to identify new instances of designated data types ',
                    'Ex3:  Assign data classifications to designated data types through tags or labels',
                    'Ex4:  Track the provenance, data owner, and geolocation of each instance of designated data types'
                  ],
                  onChangeInput: setIdam7,
                  valueComment: idam7Comments,
                  onChangeComments: setIdam7Comments,
                },
                {
                  uid: 'ID.AM-08',
                  variable: idam8,
                  questionText: 'Systems, hardware, software, services, and data are managed throughout their life cycles',
                  valueHelpText: [
                    'Ex1:  Integrate cybersecurity considerations throughout the life cycles of systems, hardware, software, and services',
                    'Ex2:  Integrate cybersecurity considerations into product life cycles',
                    'Ex3:  Identify unofficial uses of technology to meet mission objectives (i.e., “shadow IT”)',
                    'Ex4:  Periodically identify redundant systems, hardware, software, and services that unnecessarily increase the organization’s attack surface',
                    'Ex5:  Properly configure and secure systems, hardware, software, and services prior to their deployment in production',
                    'Ex6:  Update inventories when systems, hardware, software, and services are moved or transferred within the organization',
                    'Ex7:  Securely destroy stored data based on the organization’s data retention policy using the prescribed destruction method, and keep and manage a record of the destructions',
                    'Ex8:  Securely sanitize data storage when hardware is being retired, decommissioned, reassigned, or sent for repairs or replacement',
                    'Ex9:  Offer methods for destroying paper, storage media, and other physical forms of data storage',
                  ],
                  onChangeInput: setIdam8,
                  valueComment: idam8Comments,
                  onChangeComments: setIdam8Comments,
                },
              ]
          },
          {
            category: 'Risk Assessment (RA)',
            categoryDescription: 'The cybersecurity risk to the organization, assets, and individuals is understood by the organization',
              subcategories: [
                {
                  uid: 'ID.RA-01',
                  variable: idra1,
                  questionText: 'Vulnerabilities in assets are identified, validated, and recorded',
                  valueHelpText: [
                    'Ex1:  Use vulnerability management technologies to identify unpatched and misconfigured software',
                    'Ex2:  Assess network and system architectures for design and implementation weaknesses that affect cybersecurity',
                    'Ex3:  Review, analyze, or test organization-developed software to identify design, coding, and default configuration vulnerabilities',
                    'Ex4:  Assess facilities that house critical computing assets for physical vulnerabilities and resilience issues',
                    'Ex5:  Monitor sources of cyber threat intelligence for information on new vulnerabilities in products and services',
                    'Ex6:  Review processes and procedures for weaknesses that could be exploited to affect cybersecurity'
                  ],
                  onChangeInput: setIdra1,
                  valueComment: idra1Comments,
                  onChangeComments: setIdra1Comments,
                },
                {
                  uid: 'ID.RA-02',
                  variable: idra2,
                  questionText: 'Cyber threat intelligence is received from information sharing forums and sources',
                  valueHelpText: [
                    'Ex1:  Configure cybersecurity tools and technologies with detection or response capabilities to securely ingest cyber threat intelligence feeds',
                    'Ex2:  Receive and review advisories from reputable third parties on current threat actors and their tactics, techniques, and procedures (TTPs)',
                    'Ex3:  Monitor sources of cyber threat intelligence for information on the types of vulnerabilities that emerging technologies may have'
                  ],
                  onChangeInput: setIdra2,
                  valueComment: idra2Comments,
                  onChangeComments: setIdra2Comments,
                },
                {
                  uid: 'ID.RA-03',
                  variable: idra3,
                  questionText: ' Internal and external threats to the organization are identified and recorded',
                  valueHelpText: [
                    'Ex1:  Use cyber threat intelligence to maintain awareness of the types of threat actors likely to target the organization and the TTPs they are likely to use',
                    'Ex2:  Perform threat hunting to look for signs of threat actors within the environment',
                    'Ex3:  Implement processes for identifying internal threat actors'
                  ],
                  onChangeInput: setIdra3,
                  valueComment: idra3Comments,
                  onChangeComments: setIdra3Comments,
                },
                {
                  uid: 'ID.RA-04',
                  variable: idra4,
                  questionText: 'Potential impacts and likelihoods of threats exploiting vulnerabilities are identified and recorded',
                  valueHelpText: [
                    'Ex1:  Business leaders and cybersecurity risk management practitioners work together to estimate the likelihood and impact of risk scenarios and record them in risk registers',
                    'Ex2:  Enumerate the potential business impacts of unauthorized access to the organization’s communications, systems, and data processed in or by those systems',
                    'Ex3:  Account for the potential impacts of cascading failures for systems of systems'
                  ],
                  onChangeInput: setIdra4,
                  valueComment: idra4Comments,
                  onChangeComments: setIdra4Comments,
                },
                {
                  uid: 'ID.RA-05',
                  variable: idra5,
                  questionText: 'Threats, vulnerabilities, likelihoods, and impacts are used to understand inherent risk and inform risk response prioritization',
                  valueHelpText: [
                    'Ex1:  Develop threat models to better understand risks to the data and identify appropriate risk responses ',
                    'Ex2:  Prioritize cybersecurity resource allocations and investments based on estimated likelihoods and impacts',
                  ],
                  onChangeInput: setIdra5,
                  valueComment: idra5Comments,
                  onChangeComments: setIdra5Comments,
                },
                {
                  uid: 'ID.RA-06',
                  variable: idra6,
                  questionText: 'Risk responses are chosen, prioritized, planned, tracked, and communicated',
                  valueHelpText: [
                    'Ex1:  Apply the vulnerability management plan’s criteria for deciding whether to accept, transfer, mitigate, or avoid risk',
                    'Ex2:  Apply the vulnerability management plan’s criteria for selecting compensating controls to mitigate risk',
                    'Ex3:  Track the progress of risk response implementation (e.g., plan of action and milestones [POA&M], risk register, risk detail report)',
                    'Ex4:  Use risk assessment findings to inform risk response decisions and actions',
                    'Ex5:  Communicate planned risk responses to affected stakeholders in priority order'
                  ],
                  onChangeInput: setIdra6,
                  valueComment: idra6Comments,
                  onChangeComments: setIdra6Comments,
                },
                {
                  uid: 'ID.RA-07',
                  variable: idra7,
                  questionText: 'Changes and exceptions are managed, assessed for risk impact, recorded, and tracked',
                  valueHelpText: [
                    'Ex1:  Implement and follow procedures for the formal documentation, review, testing, and approval of proposed changes and requested exceptions',
                    'Ex2:  Document the possible risks of making or not making each proposed change, and provide guidance on rolling back changes',
                    'Ex3:  Document the risks related to each requested exception and the plan for responding to those risks',
                    'Ex4:  Periodically review risks that were accepted based upon planned future actions or milestones'
                  ],
                  onchangeInput: setIdra7,
                  valueComment: idra7Comments,
                  onChangeComments: setIdra7Comments,
                },
                {
                  uid: 'ID.RA-08',
                  variable: idra8,
                  questionText: 'Processes for receiving, analyzing, and responding to vulnerability disclosures are established',
                  valueHelpText: [
                    'Ex1:  Conduct vulnerability information sharing between the organization and its suppliers following the rules and protocols defined in contracts',
                    'Ex2:  Assign responsibilities and verify the execution of procedures for processing, analyzing the impact of, and responding to cybersecurity threat, vulnerability, or incident disclosures by suppliers, customers, partners, and government cybersecurity organizations',
                  ],
                  onChangeInput: setIdra8,
                  valueComment: idra8Comments,
                  onChangeComments: setIdra8Comments,
                },
                {
                  uid: 'ID.RA-09',
                  variable: idra9,
                  questionText: 'The authenticity and integrity of hardware and software are assessed prior to acquisition and use',
                  valueHelpText: [
                    'Ex1:  Assess the authenticity and cybersecurity of critical technology products and services prior to acquisition and use',
                  ],
                  onChangeInput: setIdra9,
                  valueComment: idra9Comments,
                  onChangeComments: setIdra9Comments,
                },
                {
                  uid: 'ID.RA-10',
                  variable: idra10,
                  questionText: 'Critical suppliers are assessed prior to acquisition',
                  valueHelpText: [
                    'Ex1:  Conduct supplier risk assessments against business and applicable cybersecurity requirements, including the supply chain',
                  ],
                  onChangeInput: setIdra10,
                  valueComment: idra10Comments,
                  onChangeComments: setIdra10Comments,
                },
                
              ]
          },
          {
            category: 'Improvement (IM)',
            categoryDescription: 'Improvements to organizational cybersecurity risk management processes, procedures and activities are identified across all CSF Functions',
              subcategories: [
                {
                  uid: 'ID.IM-01',
                  variable: idim1,
                  questionText: 'Improvements are identified from evaluations',
                  valueHelpText: [
                    'Ex1:  Perform self-assessments of critical services that take current threats and TTPs into consideration',
                    'Ex2:  Invest in third-party assessments or independent audits of the effectiveness of the organization’s cybersecurity program to identify areas that need improvement',
                    'Ex3:  Constantly evaluate compliance with selected cybersecurity requirements through automated means'
                  ],
                  onChangeInput: setIdim1,
                  valueComment: idim1Comments,
                  onChangeComments: setIdim1Comments,
                },
                {
                  uid: 'ID.IM-02',
                  variable: idim2,
                  questionText: 'Improvements are identified from security tests and exercises, including those done in coordination with suppliers and relevant third parties',
                  valueHelpText: [
                    'Ex1:  Identify improvements for future incident response activities based on findings from incident response assessments (e.g., tabletop exercises and simulations, tests, internal reviews, independent audits)',
                    'Ex2:  Identify improvements for future business continuity, disaster recovery, and incident response activities based on exercises performed in coordination with critical service providers and product suppliers',
                    'Ex3:  Involve internal stakeholders (e.g., senior executives, legal department, HR) in security tests and exercises as appropriate',
                    'Ex4:  Perform penetration testing to identify opportunities to improve the security posture of selected high-risk systems as approved by leadership',
                    'Ex5:  Exercise contingency plans for responding to and recovering from the discovery that products or services did not originate with the contracted supplier or partner or were altered before receipt',
                    'Ex6:  Collect and analyze performance metrics using security tools and services to inform improvements to the cybersecurity program'
                  ],
                  onChangeInput: setIdim2,
                  valueComment: idim2Comments,
                  onChangeComments: setIdim2Comments,
                },
                {
                  uid: 'ID.IM-03',
                  variable: idim3,
                  questionText: 'Improvements are identified from execution of operational processes, procedures, and activities',
                  valueHelpText: [
                    'Ex1:  Conduct collaborative lessons learned sessions with suppliers',
                    'Ex2:  Annually review cybersecurity policies, processes, and procedures to take lessons learned into account',
                    'Ex3:  Use metrics to assess operational cybersecurity performance over time'
                  ],
                  onChangeInput: setIdim3,
                  valueComment: idim3Comments,
                  onChangeComments: setIdim3Comments,
                },
                {
                  uid: 'ID.IM-04',
                  variable: idim4,
                  questionText: 'Incident response plans and other cybersecurity plans that affect operations are established, communicated, maintained, and improved',
                  valueHelpText: [
                    'Ex1:  Establish contingency plans (e.g., incident response, business continuity, disaster recovery) for responding to and recovering from adverse events that can interfere with operations, expose confidential information, or otherwise endanger the organization’s mission and viability',
                    'Ex2:  Include contact and communication information, processes for handling common scenarios, and criteria for prioritization, escalation, and elevation in all contingency plans',
                    'Ex3:  Create a vulnerability management plan to identify and assess all types of vulnerabilities and to prioritize, test, and implement risk responses',
                    'Ex4:  Communicate cybersecurity plans (including updates) to those responsible for carrying them out and to affected parties',
                    'Ex5:  Review and update all cybersecurity plans annually or when a need for significant improvements is identified'
                  ],
                  onChangeInput: setIdim4,
                  valueComment: idim4Comments,
                  onChangeComments: setIdim4Comments,
                },
              ]
          },
          
        ]
      },
      // **********PROTECT (PR)********
      {
        function: 'Protect (PR)',
        functionDescription: 'Safeguards to manage the organization’s cybersecurity risks are used',
        categories: [
          {
            category: 'Identity Management, Authentication, and Access Control (PR.AA)',
              categoryDescription: 'Access to physical and logical assets is limited to authorized users, services, and hardware and  managed commensurate with the assessed risk of unauthorized access',
              
              subcategories: [
                {
                  uid: 'PR.AA-01',
                  variable: praa1,
                  questionText: 'Identities and credentials for authorized users, services, and hardware are managed by the organization',
                  valueHelpText: [
                    'Ex1:  Initiate requests for new access or additional access for employees, contractors, and others, and track, review, and fulfill the requests, with permission from system or data owners when needed',
                    'Ex2:  Issue, manage, and revoke cryptographic certificates and identity tokens, cryptographic keys (i.e., key management), and other credentials',
                    'Ex3:  Select a unique identifier for each device from immutable hardware characteristics or an identifier securely provisioned to the device',
                    'Ex4:  Physically label authorized hardware with an identifier for inventory and servicing purposes'
                  ],
                  onChangeInput: setPraa1,
                  valueComment: praa1Comments,
                  onChangeComments: setPraa1Comments,
                },
                {
                  uid: 'PR.AA-02',
                  variable: praa2,
                  questionText: 'Identities are proofed and bound to credentials based on the context of interactions',
                  valueHelpText: [
                    'Ex1:  Verify a person’s claimed identity at enrollment time using government-issued identity credentials (e.g., passport, visa, driver’s license)',
                    'Ex2:  Issue a different credential for each person (i.e., no credential sharing)',
                  ],
                  onChangeInput: setPraa2,
                  valueComment: praa2Comments,
                  onChangeComments: setPraa2Comments,
                },
                {
                  uid: 'PR.AA-03',
                  variable: praa3,
                  questionText: 'Users, services, and hardware are authenticated',
                  valueHelpText: [
                    'Ex1:  Require multifactor authentication ',
                    'Ex2:  Enforce policies for the minimum strength of passwords, PINs, and similar authenticators ',
                    'Ex3:  Periodically reauthenticate users, services, and hardware based on risk (e.g., in zero trust architectures)',
                    'Ex4:  Ensure that authorized personnel can access accounts essential for protecting safety under emergency conditions'
                  ],
                  onChangeInput: setPraa3,
                  valueComment: praa3Comments,
                  onChangeComments: setPraa3Comments,
                },
                {
                  uid: 'PR.AA-04',
                  variable: praa4,
                  questionText: 'Identity assertions are protected, conveyed, and verified',
                  valueHelpText: [
                    'Ex1:  Protect identity assertions that are used to convey authentication and user information through single sign-on systems',
                    'Ex2:  Protect identity assertions that are used to convey authentication and user information between federated systems',
                    'Ex3:  Implement standards-based approaches for identity assertions in all contexts, and follow all guidance for the generation (e.g., data models, metadata), protection (e.g., digital signing, encryption), and verification (e.g., signature validation) of identity assertions',
                  ],
                  onChangeInput: setPraa4,
                  valueComment: praa4Comments,
                  onChangeComments: setPraa4Comments,
                },
                {
                  uid: 'PR.AA-05',
                  variable: praa5,
                  questionText: 'Access permissions, entitlements, and authorizations are defined in a policy, managed, enforced, and reviewed, and incorporate the principles of least privilege and separation of duties',
                  valueHelpText: [
                    'Ex1:  Review logical and physical access privileges periodically and whenever someone changes roles or leaves the organization, and promptly rescind privileges that are no longer needed',
                    'Ex2:  Take attributes of the requester and the requested resource into account for authorization decisions (e.g., geolocation, day/time, requester endpoint’s cyber health)',
                    'Ex3:  Restrict access and privileges to the minimum necessary (e.g., zero trust architecture)',
                    'Ex4:  Periodically review the privileges associated with critical business functions to confirm proper separation of duties'
                  ],
                  onChangeInput: setPraa5,
                  valueComment: praa5Comments,
                  onChangeComments: setPraa5Comments,
                },
                {
                  uid: 'PR.AA-06',
                  variable: praa6,
                  questionText: 'Physical access to assets is managed, monitored, and enforced commensurate with risk',
                  valueHelpText: [
                    'Ex1:  Use security guards, security cameras, locked entrances, alarm systems, and other physical controls to monitor facilities and restrict access',
                    'Ex2:  Employ additional physical security controls for areas that contain high-risk assets',
                    'Ex3:  Escort guests, vendors, and other third parties within areas that contain business-critical assets',
                  ],
                  onChangeInput: setPraa6,
                  valueComment: praa6Comments,
                  onChangeComments: setPraa6Comments,
                },
              ]
          },
          {
            category: 'Awareness and Training (PR.AT)',
              categoryDescription: 'The organization’s personnel are provided with cybersecurity awareness and training so that they can perform their cybersecurity-related tasks',
              
              subcategories: [
                {
                  uid: 'PR.AT-01',
                  variable: prat1,
                  questionText: 'Personnel are provided with awareness and training so that they possess the knowledge and skills to perform general tasks with cybersecurity risks in mind',
                  valueHelpText: [
                    'Ex1:  Provide basic cybersecurity awareness and training to employees, contractors, partners, suppliers, and all other users of the organization’s non-public resources',
                    'Ex2:  Train personnel to recognize social engineering attempts and other common attacks, report attacks and suspicious activity, comply with acceptable use policies, and perform basic cyber hygiene tasks (e.g., patching software, choosing passwords, protecting credentials) ',
                    'Ex3:  Explain the consequences of cybersecurity policy violations, both to individual users and the organization as a whole',
                    'Ex4:  Periodically assess or test users on their understanding of basic cybersecurity practices',
                    'Ex5:  Require annual refreshers to reinforce existing practices and introduce new practices'
                  ],
                  onChangeInput: setPrat1,
                  valueComment: prat1Comments,
                  onChangeComments: setPrat1Comments,
                },
                {
                  uid: 'PR.AT-02',
                  variable: prat2,
                  questionText: 'Individuals in specialized roles are provided with awareness and training so that they possess the knowledge and skills to perform relevant tasks with cybersecurity risks in mind',
                  valueHelpText: [
                    'Ex1:  Identify the specialized roles within the organization that require additional cybersecurity training, such as physical and cybersecurity personnel, finance personnel, senior leadership, and anyone with access to business-critical data',
                    'Ex2:  Provide role-based cybersecurity awareness and training to all those in specialized roles, including contractors, partners, suppliers, and other third parties',
                    'Ex3:  Periodically assess or test users on their understanding of cybersecurity practices for their specialized roles',
                    'Ex4:  Require annual refreshers to reinforce existing practices and introduce new practices'
                  ],
                  onChangeInput: setPrat2,
                  valueComment: prat2Comments,
                  onChangeComments: setPrat2Comments,
                },
              ]
          },
          {
            category: 'Data Security (PR.DS)',
              categoryDescription: 'Data are managed consistent with the organization’s risk strategy to protect the confidentiality, integrity, and availability of information',
              
              subcategories: [
                {
                  uid: 'PR.DS-01',
                  variable: prds1,
                  questionText: 'The confidentiality, integrity, and availability of data-at-rest are protected',
                  valueHelpText: [
                    'Ex1:  Use encryption, digital signatures, and cryptographic hashes to protect the confidentiality and integrity of stored data in files, databases, virtual machine disk images, container images, and other resources',
                    'Ex2:  Use full disk encryption to protect data stored on user endpoints',
                    'Ex3:  Confirm the integrity of software by validating signatures',
                    'Ex4:  Restrict the use of removable media to prevent data exfiltration',
                    'Ex5:  Physically secure removable media containing unencrypted sensitive information, such as within locked offices or file cabinets'
                  ],
                  onChangeInput: setPrds1,
                  valueComment: prds1Comments,
                  onChangeComments: setPrds1Comments,
                },
                {
                  uid: 'PR.DS-02',
                  variable: prds2,
                  questionText: 'The confidentiality, integrity, and availability of data-in-transit are protected',
                  valueHelpText: [
                    'Ex1:  Use encryption, digital signatures, and cryptographic hashes to protect the confidentiality and integrity of network communications',
                    'Ex2:  Automatically encrypt or block outbound emails and other communications that contain sensitive data, depending on the data classification',
                    'Ex3:  Block access to personal email, file sharing, file storage services, and other personal communications applications and services from organizational systems and networks ',
                    'Ex4:  Prevent reuse of sensitive data from production environments (e.g., customer records) in development, testing, and other non-production environments'
                  ],
                  onChangeInput: setPrds2,
                  valueComment: prds2Comments,
                  onChangeComments: setPrds2Comments,
                },
                {
                  uid: 'PR.DS-10',
                  variable: prds10,
                  questionText: 'The confidentiality, integrity, and availability of data-in-use are protected',
                  valueHelpText: [
                    'Ex1:  Remove data that must remain confidential (e.g., from processors and memory) as soon as it is no longer needed',
                    'Ex2:  Protect data in use from access by other users and processes of the same platform',
                  ],
                  onChangeInput: setPrds10,
                  valueComment: prds10Comments,
                  onChangeComments: setPrds10Comments,
                },
                {
                  uid: 'PR.DS-11',
                  variable: prds11,
                  questionText: 'Backups of data are created, protected, maintained, and tested',
                  valueHelpText: [
                    'Ex1:  Continuously back up critical data in near-real-time, and back up other data frequently at agreed-upon schedules',
                    'Ex2:  Test backups and restores for all types of data sources at least annually',
                    'Ex3:  Securely store some backups offline and offsite so that an incident or disaster will not damage them',
                    'Ex4:  Enforce geographic separation and geolocation restrictions for data backup storage'
                  ],
                  onChangeInput: setPrds11,
                  valueComment: prds11Comments,
                  onChangeComments: setPrds11Comments,
                },
              ]
          },
          {
            category: 'Platform Security (PR.PS)',
              categoryDescription: 'The hardware, software (e.g., firmware, operating systems, applications), and services of physical and virtual platforms are managed consistent with the organization’s risk strategy to protect their confidentiality, integrity, and availability',
              
              subcategories: [
                {
                  uid: 'PR.PS-01',
                  variable: prps1,
                  questionText: 'Configuration management practices are established and applied',
                  valueHelpText: [
                    'Ex1:  Establish, test, deploy, and maintain hardened baselines that enforce the organization’s cybersecurity policies and provide only essential capabilities (i.e., principle of least functionality)',
                    'Ex2:  Review all default configuration settings that may potentially impact cybersecurity when installing or upgrading software',
                    'Ex3:  Monitor implemented software for deviations from approved baselines'
                  ],
                  onChangeInput: setPrps1,
                  valueComment: prps1Comments,
                  onChangeComments: setPrps1Comments,
                },
                {
                  uid: 'PR.PS-02',
                  variable: prps2,
                  questionText: 'Software is maintained, replaced, and removed commensurate with risk',
                  valueHelpText: [
                    'Ex1:  Perform routine and emergency patching within the timeframes specified in the vulnerability management plan',
                    'Ex2:  Update container images, and deploy new container instances to replace rather than update existing instances',
                    'Ex3:  Replace end-of-life software and service versions with supported, maintained versions',
                    'Ex4:  Uninstall and remove unauthorized software and services that pose undue risks ',
                    'Ex5:  Uninstall and remove any unnecessary software components (e.g., operating system utilities) that attackers might misuse',
                    'Ex6:  Define and implement plans for software and service end-of-life maintenance support and obsolescence'
                  ],
                  onChangeInput: setPrps2,
                  valueComment: prps2Comments,
                  onChangeComments: setPrps2Comments,
                },
                {
                  uid: 'PR.PS-03',
                  variable: prps3,
                  questionText: 'Hardware is maintained, replaced, and removed commensurate with risk',
                  valueHelpText: [
                    'Ex1:  Replace hardware when it lacks needed security capabilities or when it cannot support software with needed security capabilities',
                    'Ex2:  Define and implement plans for hardware end-of-life maintenance support and obsolescence',
                    'Ex3:  Perform hardware disposal in a secure, responsible, and auditable manner'
                  ],
                  onChangeInput: setPrps3,
                  valueComment: prps3Comments,
                  onChangeComments: setPrps3Comments,
                },
                {
                  uid: 'PR.PS-04',
                  variable: prps4,
                  questionText: 'Log records are generated and made available for continuous monitoring',
                  valueHelpText: [
                    'Ex1:  Configure all operating systems, applications, and services (including cloud-based services) to generate log records',
                    'Ex2:  Configure log generators to securely share their logs with the organization’s logging infrastructure systems and services',
                    'Ex3:  Configure log generators to record the data needed by zero-trust architectures',
                  ],
                  onChangeInput: setPrps4,
                  valueComment: prps4Comments,
                  onChangeComments: setPrps4Comments,
                },
                {
                  uid: 'PR.PS-05',
                  variable: prps5,
                  questionText: 'Installation and execution of unauthorized software are prevented',
                  valueHelpText: [
                    'Ex1:  When risk warrants it, restrict software execution to permitted products only or deny the execution of prohibited and unauthorized software',
                    'Ex2:  Verify the source of new software and the software’s integrity before installing it',
                    'Ex3:  Configure platforms to use only approved DNS services that block access to known malicious domains',
                    'Ex4:  Configure platforms to allow the installation of organization-approved software only'
                  ],
                  onChangeInput: setPrps5,
                  valueComment: prps5Comments,
                  onChangeComments: setPrps5Comments,
                },
                {
                  uid: 'PR.PS-06',
                  variable: prps6,
                  questionText: 'Secure software development practices are integrated, and their performance is monitored throughout the software development life cycle',
                  valueHelpText: [
                    'Ex1:  Protect all components of organization-developed software from tampering and unauthorized access',
                    'Ex2:  Secure all software produced by the organization, with minimal vulnerabilities in their releases',
                    'Ex3:  Maintain the software used in production environments, and securely dispose of software once it is no longer needed',
                  ],
                  onChangeInput: setPrps6,
                  valueComment: prps6Comments,
                  onChangeComments: setPrps6Comments,
                },
              ]
          },
          {
            category: 'Technology Infrastructure Resilience (PR.IR)',
              categoryDescription: 'Security architectures are managed with the organization’s risk strategy to protect asset confidentiality, integrity, and availability, and organizational resilience',
              
              subcategories: [
                {
                  uid: 'PR.IR-01',
                  variable: prir1,
                  questionText: 'Networks and environments are protected from unauthorized logical access and usage',
                  valueHelpText: [
                    'Ex1:  Logically segment organization networks and cloud-based platforms according to trust boundaries and platform types (e.g., IT, IoT, OT, mobile, guests), and permit required communications only between segments',
                    'Ex2:  Logically segment organization networks from external networks, and permit only necessary communications to enter the organization’s networks from the external networks',
                    'Ex3:  Implement zero trust architectures to restrict network access to each resource to the minimum necessary',
                    'Ex4:  Check the cyber health of endpoints before allowing them to access and use production resources'
                  ],
                  onChangeInput: setPrir1,
                  valueComment: prir1Comments,
                  onChangeComments: setPrir1Comments,
                },
                {
                  uid: 'PR.IR-02',
                  variable: prir2,
                  questionText: 'The organization’s technology assets are protected from environmental threats',
                  valueHelpText: [
                    'Ex1:  Protect organizational equipment from known environmental threats, such as flooding, fire, wind, and excessive heat and humidity',
                    "Ex2:  Include protection from environmental threats and provisions for adequate operating infrastructure in requirements for service providers that operate systems on the organization's behalf",
                  ],
                  onChangeInput: setPrir2,
                  valueComment: prir2Comments,
                  onChangeComments: setPrir2Comments,
                },
                {
                  uid: 'PR.IR-03',
                  variable: prir3,
                  questionText: 'Mechanisms are implemented to achieve resilience requirements in normal and adverse situations',
                  valueHelpText: [
                    'Ex1:  Avoid single points of failure in systems and infrastructure',
                    'Ex2:  Use load balancing to increase capacity and improve reliability',
                    'Ex3:  Use high-availability components like redundant storage and power supplies to improve system reliability',
                  ],
                  onChangeInput: setPrir3,
                  valueComment: prir3Comments,
                  onChangeComments: setPrir3Comments,
                },
                {
                  uid: 'PR.IR-04',
                  variable: prir4,
                  questionText: 'Adequate resource capacity to ensure availability is maintained',
                  valueHelpText: [
                    'Ex1:  Monitor usage of storage, power, compute, network bandwidth, and other resources',
                    'Ex2:  Forecast future needs, and scale resources accordingly',
                  ],
                  onChangeInput: setPrir4,
                  valueComment: prir4Comments,
                  onChangeComments: setPrir4Comments,
                },
              ]
          },

        ]
      },
      // **********DETECT (DE)********
      {
        function: 'Detect (DE)',
        functionDescription: 'Possible cybersecurity attacks and compromises are found and analyzed',
        categories: [
          {
            category: 'Continuous Monitoring (DE.CM)',
              categoryDescription: 'Assets are monitored to find anomalies, indicators of compromise, and other potentially adverse events',
              
              subcategories: [
                {
                  uid: 'DE.CM-01',
                  variable: decm1,
                  questionText: 'Networks and network services are monitored to find potentially adverse events',
                  valueHelpText: [
                    'Ex1:  Monitor DNS, BGP, and other network services for adverse events',
                    'Ex2:  Monitor wired and wireless networks for connections from unauthorized endpoints',
                    'Ex3:  Monitor facilities for unauthorized or rogue wireless networks',
                    'Ex4:  Compare actual network flows against baselines to detect deviations',
                    'Ex5:  Monitor network communications to identify changes in security postures for zero trust purposes'
                  ],
                  onChangeInput: setDecm1,
                  valueComment: decm1Comments,
                  onChangeComments: setDecm1Comments,
                },
                {
                  uid: 'DE.CM-02',
                  variable: decm2,
                  questionText: 'The physical environment is monitored to find potentially adverse events',
                  valueHelpText: [
                    'Ex1:  Monitor logs from physical access control systems (e.g., badge readers) to find unusual access patterns (e.g., deviations from the norm) and failed access attempts',
                    'Ex2:  Review and monitor physical access records (e.g., from visitor registration, sign-in sheets)',
                    'Ex3:  Monitor physical access controls (e.g., locks, latches, hinge pins, alarms) for signs of tampering',
                    'Ex4:  Monitor the physical environment using alarm systems, cameras, and security guards',
                  ],
                  onChangeInput: setDecm2,
                  valueComment: decm2Comments,
                  onChangeComments: setDecm2Comments,
                },
                {
                  uid: 'DE.CM-03',
                  variable: decm3,
                  questionText: 'Personnel activity and technology usage are monitored to find potentially adverse events',
                  valueHelpText: [
                    'Ex1:  Use behavior analytics software to detect anomalous user activity to mitigate insider threats',
                    'Ex2:  Monitor logs from logical access control systems to find unusual access patterns and failed access attempts',
                    'Ex3:  Continuously monitor deception technology, including user accounts, for any usage'
                  ],
                  onChangeInput: setDecm3,
                  valueComment: decm3Comments,
                  onChangeComments: setDecm3Comments,
                },
                {
                  uid: 'DE.CM-06',
                  variable: decm6,
                  questionText: 'External service provider activities and services are monitored to find potentially adverse events',
                  valueHelpText: [
                    'Ex1:  Monitor remote and onsite administration and maintenance activities that external providers perform on organizational systems ',
                    'Ex2:  Monitor activity from cloud-based services, internet service providers, and other service providers for deviations from expected behavior',
                  ],
                  onChangeInput: setDecm6,
                  valueComment: decm6Comments,
                  onChangeComments: setDecm6Comments,
                },
                {
                  uid: 'DE.CM-09',
                  variable: decm9,
                  questionText: 'Computing hardware and software, runtime environments, and their data are monitored to find potentially adverse events',
                  valueHelpText: [
                    'Ex1:  Monitor email, web, file sharing, collaboration services, and other common attack vectors to detect malware, phishing, data leaks and exfiltration, and other adverse events',
                    'Ex2:  Monitor authentication attempts to identify attacks against credentials and unauthorized credential reuse',
                    'Ex3:  Monitor software configurations for deviations from security baselines',
                    'Ex4:  Monitor hardware and software for signs of tampering',
                    'Ex5:  Use technologies with a presence on endpoints to detect cyber health issues (e.g., missing patches, malware infections, unauthorized software), and redirect the endpoints to a remediation environment before access is authorized'
                  ],
                  onChangeInput: setDecm9,
                  valueComment: decm9Comments,
                  onChangeComments: setDecm9Comments,
                },
              ]
          },
          {
            category: 'Adverse Event Analysis (DE.AE)',
              categoryDescription: 'Anomalies, indicators of compromise, and other potentially adverse events are analyzed to characterize the events and detect cybersecurity incidents',
              
              subcategories: [
                {
                  uid: 'DE.AE-02',
                  variable: deae2,
                  questionText: 'Potentially adverse events are analyzed to better understand associated activities',
                  valueHelpText: [
                    'Ex1:  Use security information and event management (SIEM) or other tools to continuously monitor log events for known malicious and suspicious activity',
                    'Ex2:  Utilize up-to-date cyber threat intelligence in log analysis tools to improve detection accuracy and characterize threat actors, their methods, and indicators of compromise',
                    'Ex3:  Regularly conduct manual reviews of log events for technologies that cannot be sufficiently monitored through automation',
                    'Ex4:  Use log analysis tools to generate reports on their findings'
                  ],
                  onChangeInput: setDeae2,
                  valueComment: deae2Comments,
                  onChangeComments: setDeae2Comments,
                },
                {
                  uid: 'DE.AE-03',
                  variable: deae3,
                  questionText: 'Information is correlated from multiple sources',
                  valueHelpText: [
                    'Ex1:  Constantly transfer log data generated by other sources to a relatively small number of log servers',
                    'Ex2:  Use event correlation technology (e.g., SIEM) to collect information captured by multiple sources',
                    'Ex3:  Utilize cyber threat intelligence to help correlate events among log sources'
                  ],
                  onChangeInput: setDeae3,
                  valueComment: deae3Comments,
                  onChangeComments: setDeae3Comments,
                },
                {
                  uid: 'DE.AE-04',
                  variable: deae4,
                  questionText: 'The estimated impact and scope of adverse events are understood',
                  valueHelpText: [
                    'Ex1:  Use SIEMs or other tools to estimate impact and scope, and review and refine the estimates',
                    'Ex2:  A person creates their own estimates of impact and scope'
                  ],
                  onChangeInput: setDeae4,
                  valueComment: deae4Comments,
                  onChangeComments: setDeae4Comments,
                },
                {
                  uid: 'DE.AE-06',
                  variable: deae6,
                  questionText: 'Information on adverse events is provided to authorized staff and tools',
                  valueHelpText: [
                    'Ex1:  Use cybersecurity software to generate alerts and provide them to the security operations center (SOC), incident responders, and incident response tools ',
                    'Ex2:  Incident responders and other authorized personnel can access log analysis findings at all times',
                    'Ex3:  Automatically create and assign tickets in the organization’s ticketing system when certain types of alerts occur',
                    'Ex4:  Manually create and assign tickets in the organization’s ticketing system when technical staff discover indicators of compromise'
                  ],
                  onChangeInput: setDeae6,
                  valueComment: deae6Comments,
                  onChangeComments: setDeae6Comments,
                },
                {
                  uid: 'DE.AE-07',
                  variable: deae7,
                  questionText: 'Cyber threat intelligence and other contextual information are integrated into the analysis',
                  valueHelpText: [
                    'Ex1:  Securely provide cyber threat intelligence feeds to detection technologies, processes, and personnel',
                    'Ex2:  Securely provide information from asset inventories to detection technologies, processes, and personnel',
                    'Ex3:  Rapidly acquire and analyze vulnerability disclosures for the organization’s technologies from suppliers, vendors, and third-party security advisories'
                  ],
                  onChangeInput: setDeae7,
                  valueComment: deae7Comments,
                  onChangeComments: setDeae7Comments,
                },
                {
                  uid: 'DE.AE-08',
                  variable: deae8,
                  questionText: 'Incidents are declared when adverse events meet the defined incident criteria',
                  valueHelpText: [
                    'Ex1:  Apply incident criteria to known and assumed characteristics of activity in order to determine whether an incident should be declared',
                    'Ex2:  Take known false positives into account when applying incident criteria'
                  ],
                  onChangeInput: setDeae8,
                  valueComment: deae8Comments,
                  onChangeComments: setDeae8Comments,
                },
              ]
          },

        ]
      },
      // **********RESPOND (RS)********
      {
        function: 'Respond (RS)',
        functionDescription: 'Actions regarding a detected cybersecurity incident are taken',
        categories: [
          {
            category: 'Incident Management (RS.MA)',
              categoryDescription: 'Responses to detected cybersecurity incidents are managed',
              
              subcategories: [
                {
                  uid: 'RS.MA-01',
                  variable: rsma1,
                  questionText: 'The incident response plan is executed in coordination with relevant third parties once an incident is declared',
                  valueHelpText: [
                    'Ex1:  Detection technologies automatically report confirmed incidents ',
                    'Ex2:  Request incident response assistance from the organization’s incident response outsourcer',
                    'Ex3:  Designate an incident lead for each incident',
                    'Ex4:  Initiate execution of additional cybersecurity plans as needed to support incident response (for example, business continuity and disaster recovery)'
                  ],
                  onChangeInput: setRsma1,
                  valueComment: rsma1Comments,
                  onChangeComments: setRsma1Comments,
                },
                {
                  uid: 'RS.MA-02',
                  variable: rsma2,
                  questionText: 'Incident reports are triaged and validated',
                  valueHelpText: [
                    'Ex1:  Preliminarily review incident reports to confirm that they are cybersecurity-related and necessitate incident response activities',
                    'Ex2:  Apply criteria to estimate the severity of an incident'
                  ],
                  onChangeInput: setRsma2,
                  valueComment: rsma2Comments,
                  onChangeComments: setRsma2Comments,
                },
                {
                  uid: 'RS.MA-03',
                  variable: rsma3,
                  questionText: 'Incidents are categorized and prioritized',
                  valueHelpText: [
                    'Ex1:  Further review and categorize incidents based on the type of incident (e.g., data breach, ransomware, DDoS, account compromise)',
                    'Ex2:  Prioritize incidents based on their scope, likely impact, and time-critical nature',
                    'Ex3:  Select incident response strategies for active incidents by balancing the need to quickly recover from an incident with the need to observe the attacker or conduct a more thorough investigation',
                  ],
                  onChangeInput: setRsma3,
                  valueComment: rsma3Comments,
                  onChangeComments: setRsma3Comments,
                },
                {
                  uid: 'RS.MA-04',
                  variable: rsma4,
                  questionText: 'Incidents are escalated or elevated as needed',
                  valueHelpText: [
                    'Ex1:  Track and validate the status of all ongoing incidents',
                    'Ex2:  Coordinate incident escalation or elevation with designated internal and external stakeholders'
                  ],
                  onChangeInput: setRsma4,
                  valueComment: rsma4Comments,
                  onChangeComments: setRsma4Comments,
                },
                {
                  uid: 'RS.MA-05',
                  variable: rsma5,
                  questionText: 'The criteria for initiating incident recovery are applied',
                  valueHelpText: [
                    'Ex1:  Apply incident recovery criteria to known and assumed characteristics of the incident to determine whether incident recovery processes should be initiated',
                    'Ex2:  Take the possible operational disruption of incident recovery activities into account'
                  ],
                  onChangeInput: setRsma5,
                  valueComment: rsma5Comments,
                  onChangeComments: setRsma5Comments,
                },
              ]
          },
          {
            category: 'Incident Analysis (RS.AN)',
              categoryDescription: 'Investigations are conducted to ensure effective response and support forensics and recovery activities',
              
              subcategories: [
                {
                  uid: 'RS.AN-03',
                  variable: rsan3,
                  questionText: 'Analysis is performed to establish what has taken place during an incident and the root cause of the incident',
                  valueHelpText: [
                    'Ex1:  Determine the sequence of events that occurred during the incident and which assets and resources were involved in each event',
                    'Ex2:  Attempt to determine what vulnerabilities, threats, and threat actors were directly or indirectly involved in the incident',
                    'Ex3:  Analyze the incident to find the underlying, systemic root causes ',
                  ],
                  onChangeInput: setRsan3,
                  valueComment: rsan3Comments,
                  onChangeComments: setRsan3Comments,
                },
                {
                  uid: 'RS.AN-06',
                  variable: rsan6,
                  questionText: 'Actions performed during an investigation are recorded, and the records’ integrity and provenance are preserved',
                  valueHelpText: [
                    'Ex1:  Require each incident responder and others (e.g., system administrators, cybersecurity engineers) who perform incident response tasks to record their actions and make the record immutable',
                    'Ex2:  Require the incident lead to document the incident in detail and be responsible for preserving the integrity of the documentation and the sources of all information being reported'
                  ],
                  onChangeInput: setRsan6,
                  valueComment: rsan6Comments,
                  onChangeComments: setRsan6Comments,
                },
                {
                  uid: 'RS.AN-07',
                  variable: rsan7,
                  questionText: 'Incident data and metadata are collected, and their integrity and provenance are preserved',
                  valueHelpText: [
                    'Ex1:  Collect, preserve, and safeguard the integrity of all pertinent incident data and metadata (e.g., data source, date/time of collection) based on evidence preservation and chain-of-custody procedures',
                  ],
                  onChangeInput: setRsan7,
                  valueComment: rsan7Comments,
                  onChangeComments: setRsan7Comments,
                },
                {
                  uid: 'RS.AN-08',
                  variable: rsan8,
                  questionText: 'An incident’s magnitude is estimated and validated',
                  valueHelpText: [
                    'Ex1:  Review other potential targets of the incident to search for indicators of compromise and evidence of persistence',
                    'Ex2:  Automatically run tools on targets to look for indicators of compromise and evidence of persistence'
                  ],
                  onChangeInput: setRsan8,
                  valueComment: rsan8Comments,
                  onChangeComments: setRsan8Comments,
                },
              ]
              
          },
          {
            category: 'Incident Communication (RS.CO)',
              categoryDescription: 'Investigations are conducted to ensure effective response and support forensics and recovery activities',
              
              subcategories: [
                {
                  uid: 'RS.CO-02',
                  variable: rsco2,
                  questionText: 'Internal and external stakeholders are notified of incidents',
                  valueHelpText: [
                    'Ex1:  Follow the organization’s breach notification procedures after discovering a data breach incident, including notifying affected customers ',
                    'Ex2:  Notify business partners and customers of incidents in accordance with contractual requirements',
                    'Ex3:  Notify law enforcement agencies and regulatory bodies of incidents based on criteria in the incident response plan and management approval'
                  ],
                  onChangeInput: setRsco2,
                  valueComment: rsco2Comments,
                  onChangeComments: setRsco2Comments,
                },
                {
                  uid: 'RS.CO-03',
                  variable: rsco3,
                  questionText: 'Information is shared with designated internal and external stakeholders',
                  valueHelpText: [
                    'Ex1:  Securely share information consistent with response plans and information sharing agreements',
                    'Ex2:  Voluntarily share information about an attacker’s observed TTPs, with all sensitive data removed, with an Information Sharing and Analysis Center (ISAC)',
                    'Ex3:  Notify HR when malicious insider activity occurs',
                    'Ex4:  Regularly update senior leadership on the status of major incidents',
                    'Ex5:  Follow the rules and protocols defined in contracts for incident information sharing between the organization and its suppliers ',
                    'Ex6:  Coordinate crisis communication methods between the organization and its critical suppliers'
                  ],
                  onChangeInput: setRsco3,
                  valueComment: rsco3Comments,
                  onChangeComments: setRsco3Comments,
                },
              ]
          },
          {
            category: 'Incident Mitigation (RS.MI)',
              categoryDescription: 'Investigations are conducted to ensure effective response and support forensics and recovery activities',
              
              subcategories: [
                {
                  uid: 'RS.MI-01',
                  variable: rsmi1,
                  questionText: 'Incidents are contained',
                  valueHelpText: [
                    'Ex1:  Cybersecurity technologies (e.g., antivirus software) and cybersecurity features of other technologies (e.g., operating systems, network infrastructure devices) automatically perform containment actions',
                    'Ex2:  Allow incident responders to manually select and perform containment actions',
                    'Ex3:  Allow a third party (e.g., internet service provider, managed security service provider) to perform containment actions on behalf of the organization',
                    'Ex4:  Automatically transfer compromised endpoints to a remediation virtual local area network (VLAN)'
                  ],
                  onChangeInput: setRsmi1,
                  valueComment: rsmi1Comments,
                  onChangeComments: setRsmi1Comments,
                },
                {
                  uid: 'RS.MI-02',
                  variable: rsmi2,
                  questionText: 'Incidents are eradicated',
                  valueHelpText: [
                    'Ex1:  Cybersecurity technologies and cybersecurity features of other technologies (e.g., operating systems, network infrastructure devices) automatically perform eradication actions',
                    'Ex2:  Allow incident responders to manually select and perform eradication actions ',
                    'Ex3:  Allow a third party (e.g., managed security service provider) to perform eradication actions on behalf of the organization'
                  ],
                  onChangeInput: setRsmi2,
                  valueComment: rsmi2Comments,
                  onChangeComments: setRsmi2Comments,
                },
              ]
          },
        ]
      },
      // **********RECOVER (RC)********
      {
        function: 'Recover (RC)',
        functionDescription: 'Assets and operations affected by a cybersecurity incident are restored',
        categories: [
          {
            category: 'Incident Recovery Plan Execution (RC.RP)',
            categoryDescription: 'Restoration activities are performed to ensure operational availability of systems and services affected by cybersecurity incidents',
            
            subcategories: [
              {
                uid: 'RC.RP-01',
                variable: rcrp1,
                questionText: 'The recovery portion of the incident response plan is executed once initiated from the incident response process',
                valueHelpText: [
                  'Ex1:  Begin recovery procedures during or after incident response processes',
                  'Ex2:  Make all individuals with recovery responsibilities aware of the plans for recovery and the authorizations required to implement each aspect of the plans',
                ],
                onChangeInput: setRcrp1,
                valueComment: rcrp1Comments,
                onChangeComments: setRcrp1Comments,
              },
              {
                uid: 'RC.RP-02',
                variable: rcrp2,
                questionText: 'Recovery actions are selected, scoped, prioritized, and performed',
                valueHelpText: [
                  'Ex1:  Select recovery actions based on the criteria defined in the incident response plan and available resources',
                  'Ex2:  Change planned recovery actions based on a reassessment of organizational needs and resources'
                ],
                onChangeInput: setRcrp2,
                valueComment: rcrp2Comments,
                onChangeComments: setRcrp2Comments,
              },
              {
                uid: 'RC.RP-03',
                variable: rcrp3,
                questionText: 'The integrity of backups and other restoration assets is verified before using them for restoration',
                valueHelpText: [
                  'Ex1:  Check restoration assets for indicators of compromise, file corruption, and other integrity issues before use',
                ],
                onChangeInput: setRcrp3,
                valueComment: rcrp3Comments,
                onChangeComments: setRcrp3Comments,
              },
              {
                uid: 'RC.RP-04',
                variable: rcrp4,
                questionText: 'Critical mission functions and cybersecurity risk management are considered to establish post-incident operational norms',
                valueHelpText: [
                  'Ex1:  Use business impact and system categorization records (including service delivery objectives) to validate that essential services are restored in the appropriate order',
                  'Ex2:  Work with system owners to confirm the successful restoration of systems and the return to normal operations',
                  'Ex3:  Monitor the performance of restored systems to verify the adequacy of the restoration',
                ],
                onChangeInput: setRcrp4,
                valueComment: rcrp4Comments,
                onChangeComments: setRcrp4Comments,
              },
              {
                uid: 'RC.RP-05',
                variable: rcrp5,
                questionText: 'The integrity of restored assets is verified, systems and services are restored, and normal operating status is confirmed',
                valueHelpText: [
                  'Ex1:  Check restored assets for indicators of compromise and remediation of root causes of the incident before production use',
                  'Ex2:  Verify the correctness and adequacy of the restoration actions taken before putting a restored system online',
                ],
                onChangeInput: setRcrp5,
                valueComment: rcrp5Comments,
                onChangeComments: setRcrp5Comments,
              },
              {
                uid: 'RC.RP-06',
                variable: rcrp6,
                questionText: 'The end of incident recovery is declared based on criteria, and incident-related documentation is completed',
                valueHelpText: [
                  'Ex1:  Prepare an after-action report that documents the incident itself, the response and recovery actions taken, and lessons learned',
                  'Ex2:  Declare the end of incident recovery once the criteria are met',
                ],
                onChangeInput: setRcrp6,
                valueComment: rcrp6Comments,
                onChangeComments: setRcrp6Comments,
              },
            ]
          },
          {
            category: 'Incident Recovery Communication (RC.CO)',
            categoryDescription: 'Restoration activities are coordinated with internal and external parties',
            
            subcategories: [
              {
                uid: 'RC.CO-03',
                variable: rcco3,
                questionText: 'Recovery activities and progress in restoring operational capabilities are communicated to designated internal and external stakeholders',
                valueHelpText: [
                  'Ex1:  Securely share recovery information, including restoration progress, consistent with response plans and information sharing agreements',
                  'Ex2:  Regularly update senior leadership on recovery status and restoration progress for major incidents',
                  'Ex3:  Follow the rules and protocols defined in contracts for incident information sharing between the organization and its suppliers ',
                  'Ex4:  Coordinate crisis communication between the organization and its critical suppliers '
                ],
                onChangeInput: setRcco3,
                valueComment: rcco3Comments,
                onChangeComments: setRcco3Comments,
              },
              {
                uid: 'RC.CO-04',
                variable: rcco4,
                questionText: 'Public updates on incident recovery are shared using approved methods and messaging',
                valueHelpText: [
                  'Ex1:  Follow the organization’s breach notification procedures for recovering from a data breach incident',
                  'Ex2:  Explain the steps being taken to recover from the incident and to prevent a recurrence'
                ],
                onChangeInput: setRcco4,
                valueComment: rcco4Comments,
                onChangeComments: setRcco4Comments,
              },
            ]
          },
        ]
      }
];
 
  

for (let i=0; i<Object.keys(questions2)?.length; i++) {
  let tempArray = {};
  tempArray.uid = questions2[i]?.uid;
  tempArray.variable = variablesList[i];
  tempArray.questionNumber = questions2[i]?.uid;
  tempArray.questionText = questions2[i]?.questionText;
  tempArray.name = questions2[i]?.uid;
  tempArray.type = 'radiogroup';
  tempArray.radiogroupInputs = [
    {
      variable: variablesList[i],
      name: questions2[i]?.uid,
      value:"Partial", 
      // title: activeFunction === 0 ? (" Partial - Application of the organizational cybersecurity risk strategy is managed in an ad hoc manner. Prioritization is ad hoc and not formally based on objectives or threat environment.") : (""),
      title: "Partial",                           // questions2[i]?.traditional,
      onChangeInput: setVariableList[i]
    },
    {
      variable: variablesList[i],
      name: questions2[i]?.uid,
      value: "Informed",
      title: "Informed",                            // questions2[i]?.initial,
      onChangeInput: setVariableList[i]
    },
    {
      variable: variablesList[i],
      name: questions2[i]?.uid,
      value: "Repeatable",
      title: "Repeatable",                            // questions2[i]?.advanced,
      onChangeInput: setVariableList[i]
    },
    {
      variable: variablesList[i],
      name: questions2[i]?.uid,
      value: "Adaptive",
      title: "Adaptive",                              // questions2[i]?.optimal,
      onChangeInput: setVariableList[i] 
    },
    {
      variable: variablesList[i],
      name: questions2[i]?.ID,
      value: "na",
      title: "na",                                  // questions2[i]?.na,
      onChangeInput: setVariableList[i]
    }
  ];
  tempArray.onChangeInput = setVariableList[i];
  tempArray.comments = "true";
  tempArray.idComment = "setVariableCommentsList";
  tempArray.valueComment = variablesCommentsList[i];
  tempArray.onChangeComments = setVariableCommentsList[i];
  tempArray.valueComment = variablesCommentsList[i];
  tempArray.onChangeComments = setVariableCommentsList[i];
  //***Modify these settings if you want to change them from the defaults for this specific question. */
  tempArray.GridItemQuestionXS = GridItemQuestionXS;
  tempArray.GridItemInputXS = GridItemInputXS;
  tempArray.GridItemCommentsXS = GridItemCommentsXS;
  tempArray.GridItemInputSX = GridItemInputSX;
  tempArray.inputStyleWidth = inputStyleWidth;
  tempArray.inputStyleHeight = inputStyleHeight;
  tempArray.inputCommentWidth = inputCommentWidth;
  tempArray.checkboxMarginLeft = checkboxMarginLeft;
  tempArray.GridItemCheckboxContainerInputXS = GridItemCheckboxContainerInputXS;
  tempArray.helpText = "true";
  tempArray.valueHelpText = questions2[i]?.valueHelpText;

  if (questions2[i]?.category==="Organizational Context (OC)") {
    questionListGVOC.push(tempArray);
  };

  if (questions2[i]?.category==="Risk Management (RM)") {
    questionListGVRM.push(tempArray);
  };

  if (questions2[i]?.category==="Roles, Responsibilities, and Authorities (RR)") {
    questionListGVRR.push(tempArray);
  };

  if (questions2[i].category==="Policy (PO)") {
    questionListGVPO.push(tempArray);
  };

  if (questions2[i].category==="Oversight (OV)") {
    questionListGVOV.push(tempArray);
  };
  if (questions2[i].category==="Supply Chain Risk Management (SC)") {
    questionListGVSC.push(tempArray);
  };
  if (questions2[i].category==="Asset Management (AM)") {
    questionListIDAM.push(tempArray);
  };
  if (questions2[i].category==="Risk Assessment (RA)") {
    questionListIDRA.push(tempArray);
  };
  if (questions2[i].category==="Improvement (IM)") {
    questionListIDIM.push(tempArray);
  };
  if (questions2[i].category==="Identity Management, Authentication, and Access Control (AA)") {
    questionListPRAA.push(tempArray);
  };
  if (questions2[i].category==="Awareness and Training (AT)") {
    questionListPRAT.push(tempArray);
  };
  if (questions2[i].category==="Data Security (DS)") {
    questionListPRDS.push(tempArray);
  };
  if (questions2[i].category==="Platform Security (PS)") {
    questionListPRPS.push(tempArray);
  };
  if (questions2[i].category==="Technology Infrastructure Resilience (IR)") {
    questionListPRIR.push(tempArray);
  };
  if (questions2[i].category==="Continuous Monitoring (CM)") {
    questionListDECM.push(tempArray);
  };
  if (questions2[i].category==="Adverse Event Analysis (AE)") {
    questionListDEAE.push(tempArray);
  };
  if (questions2[i].category==="Incident Management (MA)") {
    questionListRSMA.push(tempArray);
  };
  if (questions2[i].category==="Incident Analysis (AN)") {
    questionListRSAN.push(tempArray);
  };
  if (questions2[i].category==="Incident Communication (CO)") {
    questionListRSCO.push(tempArray);
  };
  if (questions2[i].category==="Incident Mitigation (MI)") {
    questionListRSMI.push(tempArray);
  };
  if (questions2[i].category==="Incident Recovery Plan Execution (RP)") {
    questionListRCRP.push(tempArray);
  };
  if (questions2[i].category==="Incident Recovery Communication (CO)") {
    questionListRCCO.push(tempArray);
  };
};

// const functionsCategories = [
//   {
//     function: "Govern (GV)",
//     categories: [
//       "Organizational Context (OC)",
//       "Risk Management (RM)",
//       "Roles, Responsibilities, and Authorities (RR)",
//       "Policy (PO)",
//       "Oversight (OV)",
//       "Supply Chain Risk Management (SC)"
//     ]
//   },
//   {
//     function: "Identify (ID)",
//     categories: [
//       "Asset Management (AM)",
//       "Risk Assessment (RA)",
//       "Improvement (IM)"
//     ]
//   },
//   {
//     function: "Protect (PR)",
//     categories: [
//       "Identity Management, Authentication, and Access Control (AA)",
//       "Awareness and Training (AT)",
//       "Data Security (DS)",
//       "Platform Security (PS)",
//       "Technology Infrastructure Resilience (IR)",
//     ]
//   },
//   {
//     function: "Detect (DE)",
//     categories: [
//       "Continuous Monitoring (CM)",
//       "Adverse Event Analysis (AE)"
//     ]
//   },
//   {
//     function: "Respond (RS)",
//     categories: [
//       "Incident Management (MA)",
//       "Incident Analysis (AN)",
//       "Incident Communication (CO)",
//       "Incident Mitigation (MI)",
//     ]
//   },
//   {
//     function: "Recover (RC)",
//     categories: [
//       "Incident Recovery Plan Execution (RP)",
//       "Incident Recovery Communication (CO)"
//     ]
//   },
// ]

const allQuestionLists = [
  {
    0: questionListGVOC,
    1: questionListGVRM,
    2: questionListGVRR,
    3: questionListGVPO,
    4: questionListGVOV,
    5: questionListGVSC,
  },
  {
    0: questionListIDAM,
    1: questionListIDRA,
    2: questionListIDIM,
  },
  {
    0: questionListPRAA,
    1: questionListPRAT,
    2: questionListPRDS,
    3: questionListPRPS,
    4: questionListPRIR,

  },
  {
    0: questionListDECM,
    1: questionListDEAE,
  },
  {
    0: questionListRSMA,
    1: questionListRSAN,
    2: questionListRSCO,
    3: questionListRSMI,
  },
  {
    0: questionListRCRP,
    1: questionListRCCO
  }
];

const handleOpenInstructions = () => {
  setOpenInstructions(!openInstructions);
};


const getResults = () => {

  let gvocScoreList = [gvoc1, gvoc2, gvoc3, gvoc4, gvoc5,];
  let gvrmScoreList = [gvrm1, gvrm2, gvrm3, gvrm4, gvrm5, gvrm6, gvrm7,];
  let gvrrScoreList = [gvrr1, gvrr2, gvrr3, gvrr4,];
  let gvpoScoreList = [gvpo1, gvpo2,];
  let gvovScoreList = [gvov1, gvov2, gvov3,];
  let gvscScoreList = [gvsc1, gvsc2, gvsc3, gvsc4, gvsc5, gvsc6, gvsc7, gvsc8, gvsc9, gvsc10,];
  let idamScoreList = [idam1, idam2, idam3, idam4, idam5, idam7, idam8,];
  let idraScoreList = [idra1, idra2, idra3, idra4, idra5, idra6, idra7, idra8, idra9, idra10,];
  let idimScoreList = [idim1, idim2, idim3, idim4,];
  let praaScoreList = [praa1, praa2, praa3, praa4, praa5, praa6,];
  let pratScoreList = [prat1, prat2,];
  let prdsScoreList = [prds1, prds2, prds10, prds11,];
  let prpsScoreList = [prps1, prps2, prps3, prps4, prps5, prps6,]; 
  let prirScoreList = [prir1, prir2, prir3, prir4,];
  let decmScoreList = [decm1, decm2, decm3, decm6, decm9,];
  let deaeScoreList = [deae2, deae3, deae4, deae6, deae7, deae8,]; 
  let rsmaScoreList = [rsma1, rsma2, rsma3, rsma4, rsma5,]; 
  let rsanScoreList = [rsan3, rsan6, rsan7, rsan8, ];
  let rscoScoreList = [rsco2, rsco3,];
  let rsmiScoreList = [rsmi1, rsmi2,];
  let rcrpScoreList = [rcrp1, rcrp2, rcrp3, rcrp4, rcrp5, rcrp6,];
  let rccoScoreList = [rcco3, rcco4,];
  
  const sumList = (targetList) => {
    let temp = 0;
    // console.log(targetList);

    for (let i=0; i<targetList.length; i++) {
      if (targetList[i]==="Partial") {
        temp=temp+1;
      };
      if (targetList[i]==="Informed") {
        temp=temp+2;
      };
      if (targetList[i]==="Repeatable") {
        temp=temp+3;
      };
      if (targetList[i]==="Adaptive") {
        temp=temp+4;
      };
      if (targetList[i]==="na") {
        temp=temp+0;
      };
      if (targetList[i]==="") {
        temp=temp+0;
      };
    }
    
    return temp;
  };

  governScore.gvoc = sumList(gvocScoreList); 
  governScore.gvrm = sumList(gvrmScoreList);
  governScore.gvrr = sumList(gvrrScoreList);
  governScore.gvpo = sumList(gvpoScoreList);
  governScore.gvov = sumList(gvovScoreList);
  governScore.gvsc = sumList(gvscScoreList);

  // console.log(governScore);

  identifyScore.idam = sumList(idamScoreList);
  identifyScore.idra = sumList(idraScoreList);
  identifyScore.idim = sumList(idimScoreList);

  // console.log(identifyScore);

  protectScore.praa = sumList(praaScoreList);
  protectScore.prat = sumList(pratScoreList);
  protectScore.prds = sumList(prdsScoreList);
  protectScore.prps = sumList(prpsScoreList);
  protectScore.prir = sumList(prirScoreList);

  // console.log(protectScore);

  detectScore.decm = sumList(decmScoreList);
  detectScore.deae = sumList(deaeScoreList);

  // console.log(detectScore);

  respondScore.rsma = sumList(rsmaScoreList);
  respondScore.rsan = sumList(rsanScoreList);
  respondScore.rsco = sumList(rscoScoreList);
  respondScore.rsmi = sumList(rsmiScoreList);

  // console.log(respondScore);

  recoverScore.rcrp = sumList(rcrpScoreList);
  recoverScore.rcco = sumList(rccoScoreList);

  // console.log(recoverScore);
};



const data = [
  {
    "subject": "Govern",
    "A": gvScoreTotal / 124,
    "B": 0.59,
    "fullMark": 124

  },
  {
    "subject": "Identify",
    "A": idScoreTotal / 88,
    "B": 0.72,
    "fullMark": 88
  },
  {
    "subject": "Protect",
    "A": prScoreTotal / 116,
    "B": 0.57,
    "fullMark": 116
  },
  {
    "subject": "Detect",
    "A": deScoreTotal /68,
    "B": 0.66,
    "fullMark": 68
  },
  {
    "subject": "Respond",
    "A": rsScoreTotal / 72,
    "B": 0.8,
    "fullMark": 72
  },
  {
    "subject": "Recover",
    "A": rcScoreTotal / 40,
    "B": 0.75,
    "fullMark": 40
  }
];

const handleReturnToAssessment = (e) => {
  e.preventDefault();
  setActiveFunction(0);
}



  return (
    <Box
      display="grid"
      alignItems="downward"
      gridTemplateColumns="repeat(4, minmax(1fr, 1fr))"
      sx={{
        p: '1em',
          "& > div": { gridColumn: isNonMobile ? undefined : "span 4"},
      }}
    >
      <Grid container spacing={2} >
        {activeFunction < 6 && 
        <Grid size={2}>
        <WidgetWrapper>
          <Box >
          {questions.map((question, index) => (
            // onClick={setActiveStep(question.category)}
            <Accordion expanded={activeFunction === index} onClick={() => setActiveFunction(index)}>
            <AccordionSummary
                expandIcon={<ArrowDownwardIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
              <Typography variant='h3'>{question.function}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <>
                  {/* <Typography variant='h3'>{questionsGovern[0].function}</Typography>  */}
                  {question.categories.map((category, pos) => (
                    // onClick={setActiveStep(question.category)}
                    <ListItem key={pos} disablePadding>
                      <ListItemButton
                        onClick={() => { setActiveFunction(index); setActiveStep(pos); }}
                          sx= {{
                              backgroundColor: activeStep === question.function ? theme.palette.secondary[300] : "transparent",
                              color: activeStep === question.category ?
                                  theme.palette.primary[600] : theme.palette.primary[100],
                          }} >
                        {category.category}
                      </ListItemButton>
                    </ListItem>
                  ))}
                  
                </>
          
              </AccordionDetails>

            </Accordion>
              ))}
              <Paper sx={{ mt:'6px' }}>
                <ListItem key={8765439043} disablePadding>
                  <ListItemButton
                    onClick={() => {setActiveFunction(6); getResults();}}
                  
                      sx= {{
                        backgroundColor: activeFunction === 6 ? theme.palette.secondary[300] : "transparent",
                        color: activeFunction === 6 ?
                            theme.palette.primary[600] : theme.palette.primary[100],
                      }} >
                    <Typography variant='h3'>Results</Typography>
                  </ListItemButton>
                </ListItem>
              </Paper>

          </Box>
          </WidgetWrapper>
        </Grid>
        }

     
        
        {activeFunction < 6 ? (
        <Grid size={10}>
          <WidgetWrapper>
            <Header title={questions[activeFunction].function} subtitle={questions[activeStep].functionDescription}/>
            <Divider />
            <Typography variant='h2' sx={{ mt:'1rem' }}>{questions[activeFunction].categories[activeStep].category}</Typography>
            <Typography>{questions[activeFunction].categories[activeStep].categoryDescription} </Typography>
               {/* <Typography>
          Active Function is {activeFunction}
        </Typography>
        <Typography>
          Active Step is {activeStep}
        </Typography> */}
            <Paper >
              {openInstructions ? (
                <IconButton color="primary"  aria-label="open or close instructions" onClick={handleOpenInstructions} >
                    <ExpandCircleDownIcon sx={{ transform: 'rotate(180deg)'}} color='primary' fontSize="large" />
                    <Typography variant='h3' sx={{ ml: '1.5rem' }}><u>Instructions</u>:</Typography>
                </IconButton>
                  ) : (
                    <IconButton color="primary"  aria-label="open or close detection and response" onClick={handleOpenInstructions} >
                      <ExpandCircleDownIcon color='primary' fontSize="large" />
                      <Typography variant='h3' sx={{ ml: '1.5rem' }}>Instructions</Typography>
                    </IconButton>
                  )}
                <Divider sx={{ border:0.5, mt:'6px' }}/> 
                <Collapse in={openInstructions} timeout="auto" unmountOnExit>
                  <Grid container spacing={2} direction='columns' sx={{ display:'flex'}}>
                    
                    <Grid item size={12} sx={{ ml:'1rem' }}>
                      <Typography sx={{ p:'6px' }}>
                        Select the answer that best describes your organization's current posture for each CSF subcategory.
                      </Typography>
                      <Typography sx={{ p:'6px' }}>
                        Below are notional descriptions for this function as described in Appendix B: CSF Tiers of <Link rel='noreferrer' target='_blank' href='https://nvlpubs.nist.gov/nistpubs/CSWP/NIST.CSWP.29.pdf'><i>NIST Cybersecurity Framework 2.0</i>.</Link>
                      </Typography>
                    </Grid>

                    <Grid size={9}>
                      <Grid container spacing={1}>
                      {activeFunction === 0 ? (
                        <>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Partial: </Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>Application of the organizational cybersecurity risk strategy is managed in an ad hoc manner.</li></Typography> 
                            <Typography sx={{ p:'6px' }}><li>Prioritization is ad hoc and not formally based on objectives or threat environment.</li></Typography>
                          </Grid>
                          <Grid size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Informed</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>Risk management practices are approved by management but may not be established as organization-wide policy.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The prioritization of cybersecurity activities and protection needs is directly informed by organizational risk objectives, the threat environment, or business/mission requirements.</li></Typography>
                          </Grid>
                          <Grid size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Repeatable</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>The organization’s risk management practices are formally approved and expressed as policy.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Risk-informed policies, processes, and procedures are defined, implemented as intended, and reviewed.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Organizational cybersecurity practices are regularly updated based on the application of risk management processes to changes in business/mission requirements, threats, and technological landscape.</li></Typography>
                          </Grid>
                          <Grid size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Adaptive</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>There is an organization-wide approach to managing cybersecurity risks that uses risk-informed policies, processes, and procedures to address potential cybersecurity events. The relationship between cybersecurity risks and organizational objectives is clearly understood and considered when making decisions. Executives monitor cybersecurity risks in the same context as financial and other organizational risks. The organizational budget is based on an understanding of the current and predicted risk environment and risk tolerance. Business units implement executive vision and analyze system-level risks in the context of the organizational risk tolerances.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Cybersecurity risk management is part of the organizational culture. It evolves from an awareness of previous activities and continuous awareness of activities on organizational systems and networks. The organization can quickly and efficiently account for changes to business/mission objectives in how risk is approached and communicated.</li></Typography>
                          </Grid>
                        </>

                      ) : (
                        <>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Partial</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>There is limited awareness of cybersecurity risks at the organizational level.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization implements cybersecurity risk management on an irregular, case-by-case basis.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization may not have processes that enable cybersecurity information to be shared within the organization.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization is generally unaware of the cybersecurity risks associated with its suppliers and the products and services it acquires and uses.</li></Typography>
                          </Grid>
                          <Grid size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Informed</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>There is an awareness of cybersecurity risks at the organizational level, but an organization-wide approach to managing cybersecurity risks has not been established.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Consideration of cybersecurity in organizational objectives and programs may occur at some but not all levels of the organization. Cyber risk assessment of organizational and external assets occurs but is not typically repeatable or reoccurring.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Cybersecurity information is shared within the organization on an informal basis.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization is aware of the cybersecurity risks associated with its suppliers and the products and services it acquires and uses, but it does not act consistently or formally in response to those risks.</li></Typography>
                          </Grid>
                          <Grid item size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Repeatable</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>There is an organization-wide approach to managing cybersecurity risks. Cybersecurity information is routinely shared throughout the organization.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Consistent methods are in place to respond effectively to changes in risk. Personnel possess the knowledge and skills to perform their appointed roles and responsibilities.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization consistently and accurately monitors the cybersecurity risks of assets. Senior cybersecurity and non-cybersecurity executives communicate regularly regarding cybersecurity risks. Executives ensure that cybersecurity is considered through all lines of operation in the organization.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization risk strategy is informed by the cybersecurity risks associated with its suppliers and the products and services it acquires and uses. Personnel formally act upon those risks through mechanisms such as written agreements to communicate baseline requirements, governance structures (e.g., risk councils), and policy implementation and monitoring. These actions are implemented consistently and as intended and are continuously monitored and reviewed.</li></Typography>
                          </Grid>
                          <Grid size={11} sx={{ ml: '2rem' }}>
                            <Divider />
                          </Grid>
                          <Grid size={1} sx={{ ml:'2rem', alignContent:'center' }}>
                            <Typography>Adaptive</Typography>
                          </Grid>
                          <Grid size={10} sx={{ ml:'2rem' }}>
                            <Typography sx={{ p:'6px' }}><li>The organization adapts its cybersecurity practices based on previous and current cybersecurity activities, including lessons learned and predictive indicators. Through a process of continuous improvement that incorporates advanced cybersecurity technologies and practices, the organization actively adapts to a changing technological landscape and responds in a timely and effective manner to evolving, sophisticated threats.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>The organization uses real-time or near real-time information to understand and consistently act upon the cybersecurity risks associated with its suppliers and the products and services it acquires and uses.</li></Typography>
                            <Typography sx={{ p:'6px' }}><li>Cybersecurity information is constantly shared throughout the organization and with authorized third parties.</li></Typography>
                          </Grid>
                        </>
                      )}
                    </Grid> 
                    </Grid>

                    <Grid size={3}>
                        <Box
                          component="img"
                          width="100%"
                          alt="Description of CSF Tiers 1 through 4."
                          src={csfTiers}
                          />
                          <Typography><i>Tiers</i> characterize the rigor of an organization’s cybersecurity risk governance and management practices, and they provide context for how an organization views cybersecurity risks and the processes in place to manage those risks.</Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ border:0.5, mt:'6px', mb:'6px' }}/>                 
                </Collapse>
              </Paper>


              {/** GOVERN ORGANIZATIONAL CONTEXT Assessment */}
              <Box sx={{ border: 'solid 1px', p: '1em' }}>
                {allQuestionLists [activeFunction][activeStep]?.map(({
                  uid,
                  variable,
                  GridItemQuestionXS,
                  questionNumber,
                  questionText,
                  GridItemInputXS,
                  GridItemInputSX,
                  inputStyleWidth,
                  inputStyleHeight,
                  checkboxMarginLeft,
                  GridItemCheckboxContainerInputXS,
                  name,
                  type,
                  answerType,
                  checkboxInputs,
                  radiogroupInputs,
                  onChangeInput,
                  comments,
                  GridItemCommentsXS,
                  inputCommentWidth,
                  idComment,
                  valueComment,
                  onChangeComments,
                  helpText,
                  valueHelpText
                }) => (
                  <QuestionnaireForm
                    key={uid}
                    variable={variable}
                    GridItemQuestionXS={GridItemQuestionXS}
                    questionNumber={questionNumber}
                    questionText={questionText}
                    GridItemInputXS={GridItemInputXS}
                    GridItemInputSX={GridItemInputSX}
                    inputStyleWidth={inputStyleWidth}
                    inputStyleHeight={inputStyleHeight}
                    checkboxMarginLeft={checkboxMarginLeft}
                    GridItemCheckboxContainerInputXS={GridItemCheckboxContainerInputXS}
                    name={name}
                    type={type}
                    answerType={answerType}
                    checkboxInputs={checkboxInputs}
                    radiogroupInputs={radiogroupInputs}
                    onChangeInput={onChangeInput}
                    comments={comments}
                    GridItemCommentsXS={GridItemCommentsXS}
                    inputCommentWidth={inputCommentWidth}
                    idComment={idComment}
                    valueComment={valueComment}
                    onChangeComments={onChangeComments}
                    helpText={helpText}
                    valueHelpText={valueHelpText}
                    />
                  )
                )}
              
              <Button sx={{ m: '1rem', width: '25%' }} variant="contained" onClick={handleSubmit}>Submit</Button> 
            </Box>
          </WidgetWrapper>
        </Grid>

      ) : (
        
         
        <Grid size={12}>
           <Button sx={{ m: '1rem', width: '25%' }} variant="contained" onClick={(e)=>(handleReturnToAssessment(e))}>Return to Assessment</Button> 
          <CSFResults 
            gvoc1 = {gvoc1}
          gvoc2 = {gvoc2}
          gvoc3 = {gvoc3}
          gvoc4 = {gvoc4}
          gvoc5 = {gvoc5}
          gvrm1 = {gvrm1}
          gvrm2 = {gvrm2}
          gvrm3 = {gvrm3}
          gvrm4 = {gvrm4}
          gvrm5 = {gvrm5}
          gvrm6 = {gvrm6}
          gvrm7 = {gvrm7}
          gvrr1 = {gvrr1}
          gvrr2 = {gvrr2}
          gvrr3 = {gvrr3}
          gvrr4 = {gvrr4}
          gvpo1 = {gvpo1}
          gvpo2 = {gvpo2}
          gvov1 = {gvov1}
          gvov2 = {gvov2}
          gvov3 = {gvov3}
          gvsc1 = {gvsc1}
          gvsc2 = {gvsc2}
          gvsc3 = {gvsc3}
          gvsc4 = {gvsc4}
          gvsc5 = {gvsc5}
          gvsc6 = {gvsc6}
          gvsc7 = {gvsc7}
          gvsc8 = {gvsc8}
          gvsc9 = {gvsc9}
          gvsc10 = {gvsc10}
          idam1 = {idam1}
          idam2 = {idam2}
          idam3 = {idam3}
          idam4 = {idam4}
          idam5 = {idam5}
          idam7 = {idam7}
          idam8 = {idam8}
          idra1 = {idra1}
          idra2 = {idra2}
          idra3 = {idra3}
          idra4 = {idra4}
          idra5 = {idra5}
          idra6 = {idra6}
          idra7 = {idra7}
          idra8 = {idra8}
          idra9 = {idra9}
          idra10 = {idra10}
          idim1 = {idim1}
          idim2 = {idim2}
          idim3 = {idim3}
          idim4 = {idim4}
          praa1 = {praa1}
          praa2 = {praa2}
          praa3 = {praa3}
          praa4 = {praa4}
          praa5 = {praa5}
          praa6 = {praa6}
          prat1 = {prat1}
          prat2 = {prat2}
          prds1 = {prds1}
          prds2 = {prds2}
          prds10 = {prds10}
          prds11 = {prds11}
          prps1 = {prps1}
          prps2 = {prps2}
          prps3 = {prps3}
          prps4 = {prps4}
          prps5 = {prps5}
          prps6 = {prps6}
          prir1 = {prir1}
          prir2 = {prir2}
          prir3 = {prir3}
          prir4 = {prir4}
          decm1 = {decm1}
          decm2 = {decm2}
          decm3 = {decm3}
          decm6 = {decm6}
          decm9 = {decm9}
          deae2 = {deae2}
          deae3 = {deae3}
          deae4 = {deae4}
          deae6 = {deae6}
          deae7 = {deae7}
          deae8 = {deae8}
          rsma1 = {rsma1}
          rsma2 = {rsma2}
          rsma3 = {rsma3}
          rsma4 = {rsma4}
          rsma5 = {rsma5}
          rsan3 = {rsan3}
          rsan6 = {rsan6}
          rsan7 = {rsan7}
          rsan8 = {rsan8}
          rsco2 = {rsco2}
          rsco3 = {rsco3}
          rsmi1 = {rsmi1}
          rsmi2 = {rsmi2}
          rcrp1 = {rcrp1}
          rcrp2 = {rcrp2}
          rcrp3 = {rcrp3}
          rcrp4 = {rcrp4}
          rcrp5 = {rcrp5}
          rcrp6 = {rcrp6}
          rcco3 = {rcco3}
          rcco4 = {rcco4}
          gvoc1Comments={gvoc1Comments}
          gvoc2Comments={gvoc2Comments}
          gvoc3Comments={gvoc3Comments}
          gvoc4Comments={gvoc4Comments}
          gvoc5Comments={gvoc5Comments}
          gvrm1Comments={gvrm1Comments}
          gvrm2Comments={gvrm2Comments}
          gvrm3Comments={gvrm3Comments}
          gvrm4Comments={gvrm4Comments}
          gvrm5Comments={gvrm5Comments}
          gvrm6Comments={gvrm6Comments}
          gvrm7Comments={gvrm7Comments}
          gvrr1Comments={gvrr1Comments}
          gvrr2Comments={gvrr2Comments}
          gvrr3Comments={gvrr3Comments}
          gvrr4Comments={gvrr4Comments}
          gvpo1Comments={gvpo1Comments}
          gvpo2Comments={gvpo2Comments}
          gvov1Comments={gvov1Comments}
          gvov2Comments={gvov2Comments}
          gvov3Comments={gvov3Comments}
          gvsc1Comments={gvsc1Comments}
          gvsc2Comments={gvsc2Comments}
          gvsc3Comments={gvsc3Comments}
          gvsc4Comments={gvsc4Comments}
          gvsc5Comments={gvsc5Comments}
          gvsc6Comments={gvsc6Comments}
          gvsc7Comments={gvsc7Comments}
          gvsc8Comments={gvsc8Comments}
          gvsc9Comments={gvsc9Comments}
          gvsc10Comments={gvsc10Comments}
          idam1Comments={idam1Comments}
          idam2Comments={idam2Comments}
          idam3Comments={idam3Comments}
          idam4Comments={idam4Comments}
          idam5Comments={idam5Comments}
          idam7Comments={idam7Comments}
          idam8Comments={idam8Comments}
          idra1Comments={idra1Comments}
          idra2Comments={idra2Comments}
          idra3Comments={idra3Comments}
          idra4Comments={idra4Comments}
          idra5Comments={idra5Comments}
          idra6Comments={idra6Comments}
          idra7Comments={idra7Comments}
          idra8Comments={idra8Comments}
          idra9Comments={idra9Comments}
          idra10Comments={idra10Comments}
          idim1Comments={idim1Comments}
          idim2Comments={idim2Comments}
          idim3Comments={idim3Comments}
          idim4Comments={idim4Comments}
          praa1Comments={praa1Comments}
          praa2Comments={praa2Comments}
          praa3Comments={praa3Comments}
          praa4Comments={praa4Comments}
          praa5Comments={praa5Comments}
          praa6Comments={praa6Comments}
          prat1Comments={prat1Comments}
          prat2Comments={prat2Comments}
          prds1Comments={prds1Comments}
          prds2Comments={prds2Comments}
          prds10Comments={prds10Comments}
          prds11Comments={prds11Comments}
          prps1Comments={prps1Comments}
          prps2Comments={prps2Comments}
          prps3Comments={prps3Comments}
          prps4Comments={prps4Comments}
          prps5Comments={prps5Comments}
          prps6Comments={prps6Comments}
          prir1Comments={prir1Comments}
          prir2Comments={prir2Comments}
          prir3Comments={prir3Comments}
          prir4Comments={prir4Comments}
          decm1Comments={decm1Comments}
          decm2Comments={decm2Comments}
          decm3Comments={decm3Comments}
          decm6Comments={decm6Comments}
          decm9Comments={decm9Comments}
          deae2Comments={deae2Comments}
          deae3Comments={deae3Comments}
          deae4Comments={deae4Comments}
          deae6Comments={deae6Comments}
          deae7Comments={deae7Comments}
          deae8Comments={deae8Comments}
          rsma1Comments={rsma1Comments}
          rsma2Comments={rsma2Comments}
          rsma3Comments={rsma3Comments}
          rsma4Comments={rsma4Comments}
          rsma5Comments={rsma5Comments}
          rsan3Comments={rsan3Comments}
          rsan6Comments={rsan6Comments}
          rsan7Comments={rsan7Comments}
          rsan8Comments={rsan8Comments}
          rsco2Comments={rsco2Comments}
          rsco3Comments={rsco3Comments}
          rsmi1Comments={rsmi1Comments}
          rsmi2Comments={rsmi2Comments}
          rcrp1Comments={rcrp1Comments}
          rcrp2Comments={rcrp2Comments}
          rcrp3Comments={rcrp3Comments}
          rcrp4Comments={rcrp4Comments}
          rcrp5Comments={rcrp5Comments}
          rcrp6Comments={rcrp6Comments}
          rcco3Comments={rcco3Comments}
          rcco4Comments={rcco4Comments}

          />  
          

          {/* <WidgetWrapper>
            <Grid container spacing={2}>
              <Header title='CSF Results' />
              <Divider />
              <Grid size={4}>
              <RadarChart outerRadius={90} width={1030} height={450} data={data}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <PolarRadiusAxis angle={30} />
                <Radar name="Average of all Users" dataKey="B" stroke="#99ccff" fill="#99ccff" fillOpacity={0.6} />
                <Radar name="Your Answers" dataKey="A" stroke="#003300" fill="#003300" fillOpacity={0.6} />

                <Legend />
              </RadarChart>
              </Grid>
              

            </Grid>

          </WidgetWrapper> */}
        </Grid>
      )}

    
      </Grid>
    </Box>
  )
}

export default CSFAssessment